webpackJsonp([62],{

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 145:
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_categorys_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_config_js__ = __webpack_require__(5);





function mapCategory(value, categoryName) {
  var category = _.find(__WEBPACK_IMPORTED_MODULE_2__utils_categorys_js__["a" /* default */][categoryName], function (o) {
    return o.CategoryID == value;
  });
  if (category != null) {
    return category;
  }
  return {};
}
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DateFormat', function (value, DateFormat) {
  return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format(DateFormat);
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('CategoryTitle', function (value, categoryName) {
  var category = mapCategory(value, categoryName);
  var mapResult = category["CategoryTitle"];
  if (mapResult) {
    return mapResult;
  }
  return value;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('CategoryCode', function (value, categoryName) {
  var category = mapCategory(value, categoryName);
  var mapResult = category["CategoryCode"];
  if (mapResult) {
    return mapResult;
  }
  return value;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('mapTitle', function (value, categoryName, defaultResult) {
  var category = mapCategory(value, categoryName);
  var mapResult = category["CategoryTitle"];
  if (mapResult) {
    return mapResult;
  }
  return defaultResult || value;
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ToImgUrl', function (value) {
  var url = __WEBPACK_IMPORTED_MODULE_3__apis_config_js__["a" /* default */].getUrl("fileUrl", "");
  url = url.substring(0, url.length - 1);
  if (value.indexOf('/') == 0) {
    return url + value;
  }
  return value;
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DiffTime', function (value, end, unit) {
  var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(value);
  var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(end);
  var diffDate = endDate.diff(startDate);
  var dayS = 1000 * 60 * 60 * 24;

  var times = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(diffDate % dayS).format("HH:mm");
  var howDay = parseInt(diffDate / dayS);
  if (howDay > 0) {
    return howDay + "d " + times;
  } else {
    return times;
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DiffWeek', function (value) {
  return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).weekday();
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DurationTime', function (value) {
  var Hours = parseInt(value / 60);
  var minutes = value % 60;
  return Hours + 'h' + minutes + 'm';
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_VueI18n__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_VueI18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_VueI18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chinese__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__english__ = __webpack_require__(276);





__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_VueI18n___default.a);
var ChineseData = __WEBPACK_IMPORTED_MODULE_3__chinese__["a" /* default */];
var EnglishData = __WEBPACK_IMPORTED_MODULE_4__english__["a" /* default */];
function lange() {
  if (window.localStorage.lange == undefined) {
    if (window.navigator.languages && window.navigator.languages.length > 0) {
      return window.navigator.languages[0].split("-")[0];
    } else {
      return window.navigator.language.split("-")[0];
    }
  } else {
    return window.localStorage.lange;
  }
}
var reg = /^app./g;
var hostname = window.location.hostname;
if (!reg.test(hostname) || hostname == "app.ecs.net") {
  hostname = 'app.lchtrip.com';
}
if (hostname == 'app.wmytrip.cn') {
  ChineseData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_3__chinese__["a" /* default */]).replace(/力程商旅/g, '我们游商旅').replace(/400-088-8020/g, '400-663-0388'));
  EnglishData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_4__english__["a" /* default */]).replace(/Licheng/g, 'womenyou').replace(/www.lichengtrip.net/g, 'app.wmytrip.cn').replace(/400-088-8020/g, '400-663-0388'));
}
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_VueI18n___default.a({
  locale: lange() == 'zh' ? 'cn' : lange(),
  fallbackLocale: "en",
  messages: {
    cn: ChineseData,
    en: EnglishData
  }
}));

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_router__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_mall_router__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_system_router__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_order_router__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_trade_router__ = __webpack_require__(298);












__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var routeCache = {};

function fnMergeRoute(route) {
  if (route.name == undefined || route.name == '') {
    routes.push(route);
    return;
  }
  var cache = routeCache[route.name];
  if (!cache) {
    cache = route;
    routeCache[route.name] = route;
    routes.push(route);
    return;
  }
  cache.children = _.union(cache.children, route.children);
}

var routes = [];


$utils.each(__WEBPACK_IMPORTED_MODULE_2__views_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_3__views_mall_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_4__views_system_router__["a" /* default */], fnMergeRoute);

$utils.each(__WEBPACK_IMPORTED_MODULE_5__views_order_router__["a" /* default */], fnMergeRoute);
$utils.each(__WEBPACK_IMPORTED_MODULE_6__views_trade_router__["a" /* default */], fnMergeRoute);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var historys = $app.historys;
    var lastHistory = historys[historys.length - 1];
    if (to.path == lastHistory.path) {
      var $page = $(".page-content");
      if ($page.length > 0) {
        $page.scrollTop(lastHistory.scrollTop);
      }
    }
  }
}));

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ticketStore_js__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__siteStore_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ZoneStore_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__categoryStore_js__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialogStore_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loadStore_js__ = __webpack_require__(281);










/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex___default.a.Store({
  strict: "production" !== 'production',
  modules: {
    ticketStore: __WEBPACK_IMPORTED_MODULE_3__ticketStore_js__["a" /* default */],

    siteStore: __WEBPACK_IMPORTED_MODULE_4__siteStore_js__["a" /* default */],
    ZoneStore: __WEBPACK_IMPORTED_MODULE_5__ZoneStore_js__["a" /* default */],
    categoryStore: __WEBPACK_IMPORTED_MODULE_6__categoryStore_js__["a" /* default */],
    dialogStore: __WEBPACK_IMPORTED_MODULE_7__dialogStore_js__["a" /* default */],
    loadStore: __WEBPACK_IMPORTED_MODULE_8__loadStore_js__["a" /* default */]
  }
}));

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  "data-v-3683d978",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(557),
  /* scopeId */
  "data-v-d18f147c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(556),
  /* scopeId */
  "data-v-82527f3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(248),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 210:
/***/ (function(module, exports) {

! function (win) {
  function resize() {
    var domWidth = domEle.getBoundingClientRect().width;
    /*获取设备宽度*/
    if (domWidth / v > 540) {
      domWidth = 540 * v;
    }
    win.rem = domWidth / 7.5 * 2;
    /*windows的rem值*/
    domEle.style.fontSize = win.rem + "px";
  }
  var v, initial_scale, timeCode, dom = win.document,
    domEle = dom.documentElement,
    viewport = dom.querySelector('meta[name="viewport"]'),
    flexible = dom.querySelector('meta[name="flexible"]');
  if (viewport) {
    //viewport：<meta name="viewport"content="initial-scale=0.5, minimum-scale=0.5, maximum-scale=0.5,user-scalable=no,minimal-ui"/>
    var o = viewport.getAttribute("content").match(/initial\-scale=(["']?)([\d\.]+)\1?/);
    if (o) {
      initial_scale = parseFloat(o[2]);
      v = parseInt(1 / initial_scale);
    }
  } else {
    if (flexible) {
      var o = flexible.getAttribute("content").match(/initial\-dpr=(["']?)([\d\.]+)\1?/);
      if (o) {
        v = parseFloat(o[2]);
        initial_scale = parseFloat((1 / v).toFixed(2))
      }
    }
  }
  if (!v && !initial_scale) {
    var n = (win.navigator.appVersion.match(/android/gi), win.navigator.appVersion.match(/iphone/gi));
    v = win.devicePixelRatio;
    v = n ? v >= 3 ? 3 : v >= 2 ? 2 : 1 : 1, initial_scale = 1 / v
  }
  //没有viewport标签的情况下
  if (domEle.setAttribute("data-dpr", v), !viewport) {
    if (viewport = dom.createElement("meta"), viewport.setAttribute("name", "viewport"), viewport.setAttribute("content", "initial-scale=" + initial_scale + ", maximum-scale=" + initial_scale + ", minimum-scale=" + initial_scale + ", user-scalable=no"), domEle.firstElementChild) {
      domEle.firstElementChild.appendChild(viewport)
    } else {
      var m = dom.createElement("div");
      m.appendChild(viewport), dom.write(m.innerHTML)
    }
  }
  win.dpr = v;
  win.addEventListener("resize", function () {
    clearTimeout(timeCode), timeCode = setTimeout(resize, 300)
  }, false);
  win.addEventListener("pageshow", function (b) {
    b.persisted && (clearTimeout(timeCode), timeCode = setTimeout(resize, 300))
  }, false);
  resize();
}(window);


/***/ }),

/***/ 211:
/***/ (function(module, exports) {

module.exports = window.$;

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["b"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["d"] = getData;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRect;
function hasClass(el, className) {
  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  return reg.test(el.className);
}

function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }

  var newClass = el.className.split(' ');
  newClass.push(className);
  el.className = newClass.join(' ');
}

function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return;
  }

  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g');
  el.className = el.className.replace(reg, ' ');
}

function getData(el, name, val) {
  var prefix = 'data-';
  if (val) {
    return el.setAttribute(prefix + name, val);
  }
  return el.getAttribute(prefix + name);
}

function getRect(el) {
  if (el instanceof window.SVGElement) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  } else {
    return {
      top: el.offsetTop,
      left: el.offsetLeft,
      width: el.offsetWidth,
      height: el.offsetHeight
    };
  }
}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  "data-v-4af9488e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  "data-v-f998382e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_scroll__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bubble_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bubble_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bubble_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_js__ = __webpack_require__(212);







var COMPONENT_NAME = 'scroll';
var DIRECTION_H = 'horizontal';
var DIRECTION_V = 'vertical';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: COMPONENT_NAME,
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ScrollIndex: {
      default: 0
    },
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    listenBeforeScroll: {
      type: Boolean,
      default: false
    },
    listenScrollEnd: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: DIRECTION_V
    },
    scrollbar: {
      type: null,
      default: false
    },
    pullDownRefresh: {
      type: null,
      default: false
    },
    pullUpLoad: {
      type: null,
      default: false
    },
    startY: {
      type: Number,
      default: 0
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    freeScroll: {
      type: Boolean,
      default: false
    },
    mouseWheel: {
      type: Boolean,
      default: false
    },
    bounce: {
      default: true
    },
    zoom: {
      default: false
    }
  },
  data: function data() {
    return {
      beforePullDown: true,
      isRebounding: false,
      isPullingDown: false,
      isPullUpLoad: false,
      pullUpDirty: true,
      pullDownStyle: '',
      bubbleY: 0
    };
  },

  computed: {
    pullUpTxt: function pullUpTxt() {
      if (this.data.length <= 0) {
        return;
      }
      var moreTxt = this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.more || 'share.pullUpLoadMoreTxt';
      var noMoreTxt = this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.noMore || 'share.pullUpLoadNoMoreTxt';
      return this.pullUpDirty ? moreTxt : noMoreTxt;
    },
    refreshTxt: function refreshTxt() {
      return this.pullDownRefresh && this.pullDownRefresh.txt || 'share.RefreshTheSuccess';
    }
  },
  created: function created() {
    this.pullDownInitTop = -50;
  },
  mounted: function mounted() {
    var __self = this;
    __self.$nextTick(function () {
      __self.initScroll();
    });
  },
  destroyed: function destroyed() {
    this.$refs.scroll && this.$refs.scroll.destroy();
  },

  methods: {
    initScroll: function initScroll() {
      var _this = this;

      if (!this.$refs.wrapper) {
        return;
      }
      if (this.$refs.listWrapper && (this.pullDownRefresh || this.pullUpLoad)) {
        this.$refs.listWrapper.style.minHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom_js__["a" /* getRect */])(this.$refs.wrapper).height + 1 + 'px';
      }
      var options = {
        probeType: this.probeType,
        click: this.click,
        scrollY: this.freeScroll || this.direction === DIRECTION_V,
        scrollX: this.freeScroll || this.direction === DIRECTION_H,
        scrollbar: this.scrollbar,
        pullDownRefresh: this.pullDownRefresh,
        pullUpLoad: this.pullUpLoad,
        startY: this.startY,
        freeScroll: this.freeScroll,
        mouseWheel: this.mouseWheel,
        bounce: this.bounce,
        zoom: this.zoom
      };
      this.scroll = new __WEBPACK_IMPORTED_MODULE_1_better_scroll__["a" /* default */](this.$refs.wrapper, options);
      if (document.querySelector('.calendar')) {
        var calendar = document.querySelector('.calendar');
        var listWrapper = calendar.querySelector('.list-wrapper');
        if (listWrapper != null) {
          var li = listWrapper.getElementsByTagName('li');
          this.scroll.scrollToElement(li[this.ScrollIndex], 0);
        }
      }

      if (this.listenScroll) {
        this.scroll.on('scroll', function (pos) {
          _this.$emit('scroll', pos);
        });
      }
      if (this.listenScrollEnd) {
        this.scroll.on('scrollEnd', function (pos) {
          _this.$emit('scroll-end', pos);
        });
      }
      if (this.listenBeforeScroll) {
        this.scroll.on('beforeScrollStart', function () {
          _this.$emit('beforeScrollStart');
        });
        this.scroll.on('scrollStart', function () {
          _this.$emit('scroll-start');
        });
      }
      if (this.pullDownRefresh) {
        this._initPullDownRefresh();
      }
      if (this.pullUpLoad) {
        this._initPullUpLoad();
      }
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    },
    clickItem: function clickItem(e, item) {
      this.$emit('click', item);
    },
    destroy: function destroy() {
      this.scroll.destroy();
    },
    forceUpdate: function forceUpdate(dirty) {
      var _this2 = this;

      if (this.pullDownRefresh && this.isPullingDown) {
        this.isPullingDown = false;
        this._reboundPullDown().then(function () {
          _this2._afterPullDown();
        });
      } else if (this.pullUpLoad && this.isPullUpLoad) {
        this.pullUpDirty = dirty;
        this.isPullUpLoad = false;
        this.scroll.finishPullUp();
        this.refresh();
      } else {
        this.refresh();
      }
    },
    _initPullDownRefresh: function _initPullDownRefresh() {
      var _this3 = this;

      this.scroll.on('pullingDown', function () {
        if (_this3.data.length <= 0) {
          return;
        }
        _this3.beforePullDown = false;
        _this3.isPullingDown = true;
        _this3.$emit('pullingDown');
      });
      this.scroll.on('scroll', function (pos) {
        if (_this3.data.length <= 0) {
          return;
        }
        if (!_this3.pullDownRefresh) {
          return;
        }
        if (_this3.beforePullDown) {
          _this3.bubbleY = Math.max(0, pos.y + _this3.pullDownInitTop);
          _this3.pullDownStyle = 'top:' + Math.min(pos.y + _this3.pullDownInitTop, 10) + 'px';
        } else {
          _this3.bubbleY = 0;
        }
        if (_this3.isRebounding) {
          _this3.pullDownStyle = 'top:' + (10 - (_this3.pullDownRefresh.stop - pos.y)) + 'px';
        }
      });
    },
    _initPullUpLoad: function _initPullUpLoad() {
      var _this4 = this;

      this.scroll.on('pullingUp', function () {
        if (_this4.data.length <= 0) {
          return;
        }
        _this4.isPullUpLoad = true;
        _this4.$emit('pullingUp');
      });
    },
    _reboundPullDown: function _reboundPullDown() {
      var _this5 = this;

      var _pullDownRefresh$stop = this.pullDownRefresh.stopTime,
          stopTime = _pullDownRefresh$stop === undefined ? 600 : _pullDownRefresh$stop;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(function () {
          _this5.isRebounding = true;
          _this5.scroll.finishPullDown();
          resolve();
        }, stopTime);
      });
    },
    _afterPullDown: function _afterPullDown() {
      var _this6 = this;

      setTimeout(function () {
        _this6.pullDownStyle = 'top:' + _this6.pullDownInitTop + 'px';
        _this6.beforePullDown = true;
        _this6.isRebounding = false;
        _this6.refresh();
      }, this.scroll.options.bounceTime);
    }
  },
  watch: {
    data: function data(newVal) {
      var _this7 = this;

      setTimeout(function () {
        _this7.forceUpdate(true);
      }, this.refreshDelay);
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2__loading_vue___default.a,
    Bubble: __WEBPACK_IMPORTED_MODULE_3__bubble_vue___default.a
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    y: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      width: 50,
      height: 80
    };
  },

  computed: {
    distance: function distance() {
      return Math.max(0, Math.min(this.y * this.ratio, this.maxDistance));
    },
    style: function style() {
      return 'width:' + this.width / this.ratio + 'px;height:' + this.height / this.ratio + 'px';
    }
  },
  created: function created() {
    this.ratio = window.devicePixelRatio;
    this.width *= this.ratio;
    this.height *= this.ratio;
    this.initRadius = 18 * this.ratio;
    this.minHeadRadius = 12 * this.ratio;
    this.minTailRadius = 5 * this.ratio;
    this.initArrowRadius = 10 * this.ratio;
    this.minArrowRadius = 6 * this.ratio;
    this.arrowWidth = 3 * this.ratio;
    this.maxDistance = 40 * this.ratio;
    this.initCenterX = 25 * this.ratio;
    this.initCenterY = 25 * this.ratio;
    this.headCenter = {
      x: this.initCenterX,
      y: this.initCenterY
    };
  },
  mounted: function mounted() {
    this._draw();
  },

  methods: {
    _draw: function _draw() {
      var bubble = this.$refs.bubble;
      var ctx = bubble.getContext('2d');
      ctx.clearRect(0, 0, bubble.width, bubble.height);
      this._drawBubble(ctx);
      this._drawArrow(ctx);
    },
    _drawBubble: function _drawBubble(ctx) {
      ctx.save();
      ctx.beginPath();
      var rate = this.distance / this.maxDistance;
      var headRadius = this.initRadius - (this.initRadius - this.minHeadRadius) * rate;
      this.headCenter.y = this.initCenterY - (this.initRadius - this.minHeadRadius) * rate;

      ctx.arc(this.headCenter.x, this.headCenter.y, headRadius, 0, Math.PI, true);

      var tailRadius = this.initRadius - (this.initRadius - this.minTailRadius) * rate;
      var tailCenter = {
        x: this.headCenter.x,
        y: this.headCenter.y + this.distance
      };
      var tailPointL = {
        x: tailCenter.x - tailRadius,
        y: tailCenter.y
      };
      var controlPointL = {
        x: tailPointL.x,
        y: tailPointL.y - this.distance / 2
      };
      ctx.quadraticCurveTo(controlPointL.x, controlPointL.y, tailPointL.x, tailPointL.y);

      ctx.arc(tailCenter.x, tailCenter.y, tailRadius, Math.PI, 0, true);

      var headPointR = {
        x: this.headCenter.x + headRadius,
        y: this.headCenter.y
      };
      var controlPointR = {
        x: tailCenter.x + tailRadius,
        y: headPointR.y + this.distance / 2
      };
      ctx.quadraticCurveTo(controlPointR.x, controlPointR.y, headPointR.x, headPointR.y);
      ctx.fillStyle = 'rgb(170,170,170)';
      ctx.fill();
      ctx.strokeStyle = 'rgb(153,153,153)';
      ctx.stroke();
      ctx.restore();
    },
    _drawArrow: function _drawArrow(ctx) {
      ctx.save();
      ctx.beginPath();
      var rate = this.distance / this.maxDistance;
      var arrowRadius = this.initArrowRadius - (this.initArrowRadius - this.minArrowRadius) * rate;

      ctx.arc(this.headCenter.x, this.headCenter.y, arrowRadius - (this.arrowWidth - rate), -Math.PI / 2, 0, true);

      ctx.arc(this.headCenter.x, this.headCenter.y, arrowRadius, 0, Math.PI * 3 / 2, false);
      ctx.lineTo(this.headCenter.x, this.headCenter.y - arrowRadius - this.arrowWidth / 2 + rate);
      ctx.lineTo(this.headCenter.x + this.arrowWidth * 2 - rate * 2, this.headCenter.y - arrowRadius + this.arrowWidth / 2);
      ctx.lineTo(this.headCenter.x, this.headCenter.y - arrowRadius + this.arrowWidth * 3 / 2 - rate);
      ctx.fillStyle = 'rgb(255,255,255)';
      ctx.fill();
      ctx.strokeStyle = 'rgb(170,170,170)';
      ctx.stroke();
      ctx.restore();
    }
  },
  watch: {
    y: function y() {
      this._draw();
    }
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__explain_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__explain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__explain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Scroll_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Scroll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Scroll_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_better_scroll__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pop_out_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pop_out_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pop_out_vue__);






var STATE_HIDE = 0;
var STATE_SHOW = 1;
var COMPONENT_NAME = 'picker';
var EVENT_VALUE_CHANGE = 'valuechange';
var EVENT_CANCEL = 'cancel';
var EVENT_CHANGE = 'change';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      state: STATE_HIDE,
      stateServices: STATE_HIDE,
      Flag: 0,
      disX: 0,
      moveX: 0,
      starX: 0,
      starY: 0,
      cancelTxt: '',
      confirmTxt: '',
      Services: [],
      ShowFadeFlag: false,
      isBottom: false,
      product: {},
      ContactList: {}
    };
  },

  computed: {
    CompanyID: function CompanyID() {
      return this.$store.getters.ticketInfo.CompanyID;
    },
    UserID: function UserID() {
      return this.$store.getters.ticketInfo.UserID;
    },
    UserName: function UserName() {
      return this.$store.getters.ticketInfo.UserName;
    },
    CompanyName: function CompanyName() {
      return this.$store.getters.ticketInfo.CompanyName;
    },
    RoleTypes: function RoleTypes() {
      return this.$store.getters.categorys.types.RoleType;
    },
    UserAct: function UserAct() {
      return this.$store.getters.ticketInfo.UserAct;
    },
    ContactMobile: function ContactMobile() {
      return this.$store.getters.ticketInfo.ContactMobile;
    }
  },

  watch: {
    'UserID': function UserID() {
      var __self = this;
      if (__self.UserID) {
        __self.__init();
        __self.getContactList();
      }
    }
  },
  methods: {
    getContactList: function getContactList() {
      var __self = this;
      var data = {
        RoleID: __self.UserID
      };
      __self.$api.system.getContactList(data).then(function (json) {
        if (json.data.isSucc) {
          var result = _.find(json.data.result.entities, function (o) {
            return o.IsDefault == 1150;
          });
          if (result) {
            __self.ContactList = result;
          }
        }
      });
    },
    udInit: function udInit(Titles, ErrorMessage, Tags) {
      var __self = this;
      (function (a, h, c, b, f, g) {
        a["UdeskApiObject"] = f;a[f] = a[f] || function () {
          (a[f].d = a[f].d || []).push(arguments);
        };g = h.createElement(c);g.async = 1;g.charset = "utf-8";g.src = b;c = h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g, c);
      })(window, document, "script", "https://assets-cli.s2.udesk.cn/im_client/js/udeskApi.js", "ud");
      var timestamp = new Date().getTime();
      function getNonceStr() {
        return Math.random().toString(36).substr(2, 15);
      }
      var nonce = getNonceStr();
      var sign_str = 'nonce=' + nonce + '&timestamp=' + timestamp + '&web_token=' + __self.UserID + '&22d39dbf4792d4e66ea5d0b0308b5983';
      sign_str = sha1(sign_str);
      sign_str = sign_str.toUpperCase();
      ud({
        "code": "5b464e8",
        "link": "https://lichengtrip.s2.udesk.cn/im_client/?web_plugin_id=4981",
        "mode": "inner",
        "color": "#307AE8",
        "pos_flag": "srb",
        "language": "zh-cn",
        "session_key": "afeoqe",
        "onlineText": "联系客服，在线咨询",
        "offlineText": "客服下班，请留言",
        "targetSelector": "#btn_udesk_im",
        "selector": "#btn_udesk_im"
      });
      ud({
        "mobile": {
          "mode": "inner",
          "color": "#307AE8",
          "pos_flag": "crb",
          "onlineText": "联系客服，在线咨询",
          "offlineText": "客服下班，请留言"
        }
      });
      ud({
        "customer": {
          "nonce": nonce,
          "signature": sign_str,
          "timestamp": timestamp,
          "c_name": __self.UserName,
          "web_token": __self.UserID,
          "customer_token": __self.UserID,
          "c_org": __self.CompanyName,
          "c_tags": Tags,
          "c_phone": __self.ContactList.ContactPhone,
          "c_email": __self.ContactList.ContactEmail,
          "c_cf_页面信息": Titles,
          "c_cf_近期报错": ErrorMessage

        }
      });
      ud({
        "panel": {
          "css": {
            "top": "0",
            "left": "0"
          },
          "onToggle": function onToggle(data) {
            if (data.visible) {
              console.log('窗口打开');
            } else {
              console.log('窗口关闭');
              __self.hide();
            }
          }
        }
      });
    },
    showUdesk: function showUdesk() {
      var __self = this;
      if (__self.CompanyID && window.lch_udesk && window.lch_udesk.show) {
        if ($utils.ErrorMessage.length > 0) {
          __self.product['错误信息'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()($utils.ErrorMessage);
        }
        var Titles = '无页面信息';
        if ($utils.getTitle()) {
          Titles = $utils.getTitle();
        }
        var ErrorMessage = '无错误信息';
        if ($utils.ErrorMessage.length > 0) {
          ErrorMessage = $utils.ErrorMessage.join('\n');
        }
        var Tags = __self.Services.map(function (o) {
          return o.UserName;
        });
        Tags = Tags.join(',');
        var paramsObj = {
          c_name: __self.UserName,
          c_org: __self.CompanyName,
          c_tags: Tags,
          c_phone: __self.ContactList.ContactPhone,
          c_email: __self.ContactList.ContactEmail,
          c_cf_titles: Titles,
          c_cf_errormessage: ErrorMessage,
          web_token: __self.UserID,
          customer_token: __self.UserID
        };
        window.lch_udesk.show(paramsObj);
      }
    },
    cancel: function cancel() {
      var __self = this;
      __self.stateServices = STATE_HIDE;
      __self.ShowFadeFlag = true;
    },
    show: function show() {
      var __self = this;
      __self.state = STATE_SHOW;
      if (__self.CompanyID) {
        if ($utils.ErrorMessage.length > 0) {
          __self.product['错误信息'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()($utils.ErrorMessage);
        }
        var Titles = '无页面信息';
        if ($utils.getTitle()) {
          Titles = $utils.getTitle();
        }
        var ErrorMessage = '无错误信息';
        if ($utils.ErrorMessage.length > 0) {
          ErrorMessage = $utils.ErrorMessage.join('\n');
        }
        var Tags = __self.Services.map(function (o) {
          return o.UserName;
        });
        Tags = Tags.join(',');
        if (!window.lch_udesk) {
          __self.udInit(Titles, ErrorMessage, Tags);
        }
      }
    },
    hide: function hide() {
      var __self = this;
      __self.state = STATE_HIDE;
      __self.ShowFadeFlag = false;
    },
    Touchstart: function Touchstart(e) {
      var __self = this;
      var CustomerServicesEle = document.getElementById('CustomerServices');
      __self.Flag = 0;

      __self.disX = e.touches[0].clientX - CustomerServicesEle.offsetLeft;
      __self.disY = e.touches[0].clientY - CustomerServicesEle.offsetTop;
      __self.starX = e.touches[0].clientX;
      __self.starY = e.touches[0].clientY;
    },
    Touchmove: function Touchmove(e) {
      var __self = this;
      if (__self.state == STATE_SHOW) {
        return;
      }
      var CustomerServicesEle = document.getElementById('CustomerServices');
      var Ele = document.documentElement;
      var L = void 0,
          T = void 0,
          R = void 0,
          B = void 0,
          starXEnd = void 0,
          starYEnd = void 0,
          moveX = void 0,
          moveY = void 0;
      __self.Flag = 1;
      L = e.touches[0].clientX - __self.disX;
      T = e.touches[0].clientY - __self.disY;
      starXEnd = e.touches[0].clientX - __self.starX;
      starYEnd = e.touches[0].clientY - __self.starY;
      if (L < 0) {
        L = 0;
      } else if (L > Ele.clientWidth - CustomerServicesEle.offsetWidth) {
        L = Ele.clientWidth - CustomerServicesEle.offsetWidth;
      }
      if (T < 0) {
        T = 0;
      } else if (T > Ele.clientHeight - CustomerServicesEle.offsetHeight) {
        T = Ele.clientHeight - CustomerServicesEle.offsetHeight;
      }
      moveX = L + "px";
      moveY = T + "px";
      if (T <= 150) {
        __self.isBottom = true;
      } else {
        __self.isBottom = false;
      }
      CustomerServicesEle.style.left = moveX;
      CustomerServicesEle.style.top = moveY;
    },
    Touchend: function Touchend(e) {},
    __init: function __init() {
      var __self = this;
      if (__self.CompanyID) {
        var model = {
          PageSize: 99999,
          RoleType: __self.RoleTypes.Company,
          RoleID: __self.CompanyID,
          Superior: {
            RoleType: __self.RoleTypes.User,
            RootID: "S00000000120"
          }
        };
        __self.$api.system.getOwners(model).then(function (o) {
          if (o.data.isSucc) {
            __self.Services = o.data.result;
          }
        });
      } else {
        __self.Services = [];
      }
    },
    ShowFade: function ShowFade(e) {
      var __self = this;
      if (__self.Flag === 0) {
        __self.ShowFadeFlag = !__self.ShowFadeFlag;
        if (__self.ShowFadeFlag) {
          __self.show();
        } else {
          __self.state = STATE_HIDE;
          $utils.getTitle = function () {
            return undefined;
          };
        }
      }
    },
    ToFeedBack: function ToFeedBack() {
      var __self = this;
      __self.$router.push({
        path: '/system/feedBack'
      });
      __self.ShowFade();
    },
    customerServices: function customerServices() {
      var __self = this;
      if (__self.Flag === 0) {
        __self.__init();
        __self.stateServices = STATE_SHOW;
        __self.ShowFadeFlag = !__self.ShowFadeFlag;
      }
    },
    messageNotify: function messageNotify() {
      window.location.href = 'tel://400-088-8020';
    }
  },
  components: {
    popOut: __WEBPACK_IMPORTED_MODULE_4__pop_out_vue___default.a,
    Scroll: __WEBPACK_IMPORTED_MODULE_2__Scroll_vue___default.a,
    explain: __WEBPACK_IMPORTED_MODULE_1__explain_vue___default.a
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    dialogConfig: function dialogConfig() {
      return this.$store.getters.dialogConfig;
    }
  },
  methods: {}
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(73);



var STATE_HIDE = 0;
var STATE_SHOW = 1;
var COMPONENT_NAME = 'explain';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: COMPONENT_NAME,
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String
    },
    cancelTxt: {
      type: String
    },
    confirmTxt: {
      type: String
    },
    selectedIndex: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Boolean,
      default: false
    },
    closeModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      state: STATE_HIDE
    };
  },

  methods: {
    confirm: function confirm() {},
    cancel: function cancel() {
      if (!this.closeModal) {
        this.hide();
      }
    },
    show: function show() {
      this.state = STATE_SHOW;
    },
    hide: function hide() {
      this.state = STATE_HIDE;
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    loadConfig: function loadConfig() {
      return this.$store.getters.loadConfig;
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keep_alive_js__ = __webpack_require__(294);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__keep_alive_js__["a" /* default */]);

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var COMPONENT_NAME = 'loading';
/* harmony default export */ __webpack_exports__["default"] = ({
  name: COMPONENT_NAME
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scroll_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scroll_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Scroll_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_better_scroll__ = __webpack_require__(73);




var STATE_HIDE = 0;
var STATE_SHOW = 1;
var COMPONENT_NAME = 'picker';
var EVENT_VALUE_CHANGE = 'valuechange';
var EVENT_CANCEL = 'cancel';
var EVENT_CHANGE = 'change';
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      state: STATE_HIDE
    };
  },

  props: {
    cancelTxt: {
      type: String
    },
    confirmTxt: {
      type: String
    }
  },
  methods: {
    confirm: function confirm() {
      this.hide();
    },
    cancel: function cancel() {
      this.hide();
    },
    show: function show(Product) {
      if (Product != '') {
        this.hotelProduct = Product;
      }
      this.state = STATE_SHOW;
    },
    hide: function hide() {
      this.state = STATE_HIDE;
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_0__Scroll_vue___default.a
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'adapter',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    saveAdviseInfo: function saveAdviseInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/advise/update'), data);
    },
    getIndexExtras: function getIndexExtras(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ExtraInfo/IndexExtras'), data);
    }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'base',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getCountrys: function getCountrys(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/CountryInfo/Countrys/' + id));
  },
  getCitys: function getCitys(countryID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourServers/GetCityInfo/' + countryID));
  },
  getTrainStation: function getTrainStation(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourServers/LoadCityInfo'), data);
  },
  getdistinct: function getdistinct(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/DistrictInfo/GetDist'), data);
  },
  getZoneList: function getZoneList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ZoneInfo/List'), data).then(function (json) {
      if (json.data.isSucc) {
        for (var i = 0; i < json.data.result.entities.length; i++) {
          var result = json.data.result.entities[i];
          var keywords = result.CityName + ',' + result.CountryName + ',' + result.ZoneName + ',' + result.ZoneCode + ',' + result.ZoneShortSpell + ',' + result.ZoneSpell;
          result.keywords = keywords;
          result.label = result.ZoneName;
        }
      }
      return json;
    });
  },
  getAirwayInfoList: function getAirwayInfoList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AirwayInfo/List'), data);
  },
  gettripcomVersion: function gettripcomVersion() {
    var reg = /^app./g;
    var hostname = window.location.hostname;
    if (!reg.test(hostname) || hostname == "app.ecs.net") {
      hostname = 'app.lchtrip.com';
    }
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/static/' + hostname.replace(/\./g, '') + '/version.json').replace('/api/base', ''));
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bill',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  cashier: function cashier(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trade/cashier'), data);
  },
  redirect: function redirect(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trade/redirect'), data);
  },
  getTradeDeals: function getTradeDeals(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/GetTradeDeals?UniqueID=' + UniqueID));
  },
  GetUserPayment: function GetUserPayment(orderid, unionid) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TradeDeal/GetUserPayment?OrderID=' + orderid + '&UnionID=' + unionid));
  },
  getUserTicketStatus: function getUserTicketStatus(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/tradedetail/SearchUserTicket'), data);
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'btrip',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getBtripTexts: function getBtripTexts(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/BtripText/BtripTexts/' + id));
  },
  getBtripTask: function getBtripTask(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BtripTask/GetBtripTask'), data);
  },
  getTripRule: function getTripRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TripRule/GetTripRule'), data);
  },
  getBtripTextList: function getBtripTextList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BtripText/list'), data);
  },
  saveTripRejectReason: function saveTripRejectReason(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/BtripTask/Update'), data);
  },
  getTripFlowDetail: function getTripFlowDetail(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TripFlow/Details/' + id));
  },
  getProjectList: function getProjectList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Project/List'), data);
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chargepolicy',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getChargeList: function getChargeList(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ChargeInfo/List'), data);
    },
    getChargeDetails: function getChargeDetails(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/ChargeInfo/Details/' + id));
    },
    saveChargeInfo: function saveChargeInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/ChargeInfo/Save'), data);
    },
    getProductInfo: function getProductInfo(data, options) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/ProductInfo'), data, options);
    }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flight',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  CheckRepeatOrder: function CheckRepeatOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightOrder/CheckRepeatOrder'), data, {
      failTips: false
    });
  },
  getCreateOrder: function getCreateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightOrder/CreateOrderByProduct'), data);
  },
  OrderDetails: function OrderDetails(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/FlightOrder/OrderDetails?UniqueID=' + UniqueID));
  },
  OrderCancel: function OrderCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/FlightOrder/OrderCancel?UniqueID=' + id));
  },
  RefundJudge: function RefundJudge(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/FlightOrder/RefundJudge?UniqueID=' + UniqueID));
  },
  CreateAmend: function CreateAmend(amend) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightOrder/CreateAmend'), amend);
  },
  OrderChange: function OrderChange(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightOrder/FlightOrderChange'), data);
  },
  OrderSubmit: function OrderSubmit(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/FlightOrder/OrderSubmit/' + UniqueID));
  },
  UpdateOrderStatus: function UpdateOrderStatus(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/FlightOrder/UpdateOrderStatus?UniqueID=' + id));
  },
  OrderRefund: function OrderRefund(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightOrder/OrderRefund'), data);
  },
  getReplenishOrderInfomation: function getReplenishOrderInfomation(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightOrder/ReplenishOrderInfomation'), data);
  },
  CreateOrderByPreference: function CreateOrderByPreference(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightOrder/CreateOrderByPreference'), data);
  },
  SearchOrders: function SearchOrders(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/FlightOrder/SearchOrders?UniqueID=' + id));
  },
  OrderRefundCancel: function OrderRefundCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/FlightOrder/OrderRefundCancel?UniqueID=' + id));
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flightpolicy',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getFlightLists: function getFlightLists(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightSearch/Search'), data);
  },
  SaveFlight: function SaveFlight(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightSearch/SaveFlight'), data);
  },
  getProductInfo: function getProductInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightPolicy/ProductInfo'), data);
  },
  SearchAmendPolicy: function SearchAmendPolicy(id, applyarea) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/Product/RuleInfo?id=' + id + '&ApplyArea=' + applyarea), {
      failTips: false
    });
  },
  getCreatePolicy: function getCreatePolicy(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/FlightPolicy/CreatePolicy'), data);
  },
  getProductList: function getProductList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/product/list'), data);
  },
  getProductGoods: function getProductGoods(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/product/GetGoods'), data);
  },
  searchPolicyRate: function searchPolicyRate(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/AmendPolicy/CalcPrice/' + id), data);
  },
  GetChangeOrderPrice: function GetChangeOrderPrice(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/amendpolicy/GetChangeOrderPrice'), data);
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hotel',
  CheckRepeatOrder: function CheckRepeatOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/HotelOrder/CheckRepeatOrder'), data, {
      failTips: false
    });
  },
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getCreateOrder: function getCreateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateOrder'), data);
  },
  OrderDetails: function OrderDetails(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderDetails?UniqueID=' + UniqueID));
  },
  RefundJudge: function RefundJudge(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelOrder/RefundJudge?UniqueID=' + UniqueID));
  },
  CreateAmend: function CreateAmend(amend) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateAmend'), amend);
  },
  OrderCancel: function OrderCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderCancel?UniqueID=' + id));
  },
  OrderSubmit: function OrderSubmit(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderSubmit/' + UniqueID));
  },
  UpdateOrderStatus: function UpdateOrderStatus(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelOrder/UpdateOrderStatus?UniqueID=' + id));
  },
  OrderRefund: function OrderRefund(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/HotelOrder/OrderRefund'), data);
  },
  CreateOrderByPreference: function CreateOrderByPreference(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/HotelOrder/CreateOrderByPreference'), data);
  },
  SearchOrders: function SearchOrders(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelOrder/SearchOrders?UniqueID=' + id));
  },
  OrderRefundCancel: function OrderRefundCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelOrder/OrderRefundCancel?UniqueID=' + id));
  },
  getRefundPrice: function getRefundPrice(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/hotelorder/RefundPrice?id=' + id));
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hotelpolicy',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getProductLists: function getProductLists(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Product/list'), data, { failTips: false });
  },
  getIHotelList: function getIHotelList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/IHotelPolicy/IHotelList'), data);
  },
  getProductInfo: function getProductInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/HotelPolicy/ProductInfo'), data);
  },
  IHotelInfo: function IHotelInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/IHotelPolicy/IHotelInfo'), data);
  },
  getProductDetail: function getProductDetail(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Product/ProductDetail'), data);
  },
  Citylist: function Citylist(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/HotelPolicy/Citylist/' + id));
  },
  getThemeFacilityList: function getThemeFacilityList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/product/SearchFacilities?filterCode=' + data));
  },
  getCityBusiness: function getCityBusiness(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/product/CityBusiness'), data);
  },
  getRiskInfos: function getRiskInfos(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/riskinfo/SearchRiskInfo'), data, { failTips: false });
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'huilianyi',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    searchapprovals: function searchapprovals() {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl("/huilianyi/searchApproval"));
    },
    booking: function booking(id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/huilianyi/booking?id=' + id));
    }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'insurancepolicy',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getInsuranceMatching: function getInsuranceMatching(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyThrow/InsuranceMatching'), data);
  },
  getProductInfo: function getProductInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/PolicyInfo/productInfo'), data, { failTips: false });
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'logs',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getLogInfo: function getLogInfo(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/LogInfo/List'), data);
    },
    getLogs: function getLogs(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/LogInfo/Logs'), data);
    }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'message',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    }
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'order',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getAllOrderList: function getAllOrderList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Order/List'), data);
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, exports) {



/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'side',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getFileContent: function getFileContent(filetype, filepath) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/Storage/Index/' + filetype + '?filepath=' + filepath), { failTips: false });
    },
    getUploadImg: function getUploadImg(data, id) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/Storage/UploadImg?id=' + id), data, { failTips: false });
    },
    getValidImageUrl: function getValidImageUrl() {
        return this.getUrl("/Common/ValidCode") + '?' + Math.random();
    }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'storage',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    getUploadImg: function getUploadImg(data, id, type) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/upload/' + type + '/' + id), data, { failTips: false });
    }
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(5);


var _name$getUrl$getConsu;




/* harmony default export */ __webpack_exports__["a"] = (_name$getUrl$getConsu = {
  name: 'system',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].getUrl(this.name, url);
  },
  getConsumers: function getConsumers(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/RoleInfo/getConsumers"), data);
  },
  getRoleInfo: function getRoleInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/RoleInfo/Details"), data);
  },
  getSiteInfo: function getSiteInfo() {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/Security/GetSiteInfo'));
  },
  getRoleList: function getRoleList(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/RoleInfo/List"), data);
  },
  login: function login(loginInfo) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/Security/Login"), loginInfo);
  },
  saveRoleInfo: function saveRoleInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/RoleInfo/Update"), data);
  },
  getTicketInfo: function getTicketInfo(options) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/Security/GetTicketInfo"), "", options);
  },
  logout: function logout() {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/Security/Logout"), "");
  },
  sendCode: function sendCode(UserAct) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/SendCode'), UserAct);
  },
  sendValidCode: function sendValidCode(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/SendValidCode'), data);
  },
  register: function register(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/Register'), data);
  },
  getFlowInfo: function getFlowInfo(FlowID) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/FlowInfo/Details/' + FlowID));
  },
  getContactList: function getContactList(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/ContactInfo/List'), data);
  },
  getContactInfo: function getContactInfo(ContactID) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/ContactInfo/Details/' + ContactID));
  },
  saveContactInfo: function saveContactInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/ContactInfo/Update'), data);
  },
  deleteContactInfo: function deleteContactInfo(ContactID) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/ContactInfo/Delete/' + ContactID));
  },
  deleteRoleInfo: function deleteRoleInfo(id, spaceId, ownerType) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/RoleInfo/Delete/' + id + '?spaceId=' + spaceId + '&ownerType=' + ownerType));
  },
  checkAccount: function checkAccount(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/CheckAccount'), data);
  },
  checkCode: function checkCode(data) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/checkCode'), data);
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'sendValidCode', function sendValidCode(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/SendValidCode'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'resetPwd', function resetPwd(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/ResetPwd'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'getInvoiceList', function getInvoiceList(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/InvoiceInfo/List'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'saveInvoiceInfo', function saveInvoiceInfo(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/InvoiceInfo/Update'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'deleteInvoiceInfo', function deleteInvoiceInfo(InvoiceID) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/InvoiceInfo/Delete/' + InvoiceID));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'getAccountList', function getAccountList(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/UserAccount/List"), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'initializePassword', function initializePassword(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/UserAccount/InitializePassword"), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'deleteAccountInfo', function deleteAccountInfo(UserAct) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/UserAccount/Delete?UserAct=' + UserAct));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'authSendCode', function authSendCode(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/auth/SendCode'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'authBind', function authBind(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/auth/Bind'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'getOwners', function getOwners(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl("/RoleInfo/Owners"), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'getConferList', function getConferList(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/ConferInfo/List'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'getConferInfo', function getConferInfo(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/ConferInfo/Details'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'saveConferInfo', function saveConferInfo(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/ConferInfo/Save'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'deleteConferInfo', function deleteConferInfo(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/ConferInfo/Delete'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'getConferInfoLists', function getConferInfoLists(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('configinfo/ConfigInfoList'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'saveConfigInfo', function saveConfigInfo(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('configinfo/ConfigInfoSave'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'AccountExists', function AccountExists(data) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(this.getUrl('/Security/AccountExists'), data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$getUrl$getConsu, 'getReferInfo', function getReferInfo(id) {
  return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get(this.getUrl('/auth/getReferInfo?ReferID=' + id));
}), _name$getUrl$getConsu);

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tour',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  RefundJudge: function RefundJudge(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/RefundJudge?UniqueID=' + UniqueID));
  },
  OrderCancel: function OrderCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderCancel?UniqueID=' + id));
  },
  OrderSubmit: function OrderSubmit(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderSubmit/' + UniqueID));
  },
  OrderRefund: function OrderRefund(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/OrderRefund'), data);
  },
  CreateOrderByPreference: function CreateOrderByPreference(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TourOrder/CreateOrderByPreference'), data);
  },
  SearchOrders: function SearchOrders(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/SearchOrders?UniqueID=' + id));
  },
  OrderRefundCancel: function OrderRefundCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TourOrder/OrderRefundCancel?UniqueID=' + id));
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'tourpolicy',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bill',
    getUrl: function getUrl(url) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
    },
    cashier: function cashier(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trade/cashier'), data);
    },
    redirect: function redirect(data) {
        return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/trade/redirect'), data);
    }
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'train',
  CheckRepeatOrder: function CheckRepeatOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/CheckRepeatOrder'), data, {
      failTips: false
    });
  },
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getCreateOrder: function getCreateOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/CreateOrder'), data);
  },
  ConsumerVerification: function ConsumerVerification(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/ConsumerVerification'), data);
  },
  OrderDetails: function OrderDetails(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/OrderDetails?UniqueID=' + UniqueID));
  },
  RefundJudge: function RefundJudge(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/RefundJudge?UniqueID=' + UniqueID));
  },
  CreateAmend: function CreateAmend(amend) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/CreateAmend'), amend);
  },
  OrderChange: function OrderChange(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/TrainOrderChange'), data);
  },
  OrderCancel: function OrderCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/OrderCancel?UniqueID=' + id));
  },
  OrderSubmit: function OrderSubmit(UniqueID) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/OrderSubmit/' + UniqueID));
  },
  UpdateOrderStatus: function UpdateOrderStatus(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/UpdateOrderStatus?UniqueID=' + id));
  },
  OrderRefund: function OrderRefund(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainOrder/OrderRefund'), data);
  },
  SearchOrders: function SearchOrders(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/SearchOrders?UniqueID=' + id));
  },
  OrderRefundCancel: function OrderRefundCancel(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/OrderRefundCancel?UniqueID=' + id));
  },
  GetSimpleOrder: function GetSimpleOrder(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/TrainOrder/GetSimpleOrder?UniqueID=' + id));
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'trainpolicy',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getTrainLists: function getTrainLists(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainSearch/Search'), data);
  },
  getStationList: function getStationList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainSearch/Station'), data);
  },
  getProductInfo: function getProductInfo(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/TrainPolicy/ProductInfo'), data);
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'work',
  getUrl: function getUrl(url) {
    return __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].getUrl(this.name, url);
  },
  getWorkTasks: function getWorkTasks(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/WorkTask/GetWorkTasks'), data);
  },
  TaskResolve: function TaskResolve(id, options) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/WorkTask/Resolve/' + id), options);
  },
  TaskReject: function TaskReject(id, options) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get(this.getUrl('/WorkTask/Reject/' + id), options);
  },
  List: function List(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post(this.getUrl('/WorkTask/List'), data);
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _mall, _Categorys;

/* harmony default export */ __webpack_exports__["a"] = ({
  mall: (_mall = {
    allprice: '全价',
    discount: '折',
    GivenName: '英文名',
    Surname: '英文姓',
    selectedseat: '已选座',
    noselectseat: '未选座',
    takeOff: '起飞',
    FillInfo: '填写须知',
    ExpiryDate: '有效期',
    StartTime: '开始时间',
    EndTime: '结束时间',
    ToProcessDate: '去程日期',
    backTracking: '返程日期',
    sharing: '共享',
    AirplaneModelTxt: '机型',
    ticketfeeFloat: '此价格不含机建燃油税费',
    peopleTypeExplain: '儿童婴儿预订说明',
    bookingTicketExplain: '如需预订儿童/婴儿票，请联系本公司客服。',
    onlySeeDirect: '仅看直飞',
    hiddenSharedFlight: '隐藏共享航班',
    ActualCarrier: '实际承运',
    stayTxt: '停留',
    turnTxt: '转',
    priceRemarks: '以下费用均为“1成人或1儿童或1婴儿”的人均价',
    AgreementPrice: '商务推荐',
    tax: '税',
    trainHolderKeyWords: '国内火车票',
    bookingRemarks: '一次最多只能预订5位乘客',
    beginTxt: '始',
    passTxt: '过',
    endTxt: '终',
    StandingOrder: '站序',
    stationName: '站名',
    arrivalTimeTxt: '到时',
    departTimeTxt: '发时',
    departDate: '出发日期',
    arrivalDate: '到达日期',
    hotelHolderKeyWords: '请输入关键字/酒店名等',
    HotelRemarks: '订房间请不要超过5间，入住日期不要超过20晚。若需特殊预订请联系我司客服。',
    TrainRemarks: '提示：购票时间为早7:30—晚22:30。购票、改签和退票须不晚于开车前30分钟。当天内行程请在10分钟内支付，24小时以外行程请在25分钟内支付。',
    NoTrainSearch: '当前时段不提供车次查询服务',
    mapTxt: '地图/导航',
    detailsOrFacilities: '详情/设施',
    noSooner: '无早',
    breakfast: '早餐',
    breakfastTxt: '含早',
    noCancellation: '不可取消',
    timeToCancel: '限时取消',
    RoomsTxt: '房间数',
    hotelUnit: '晚',
    checkInTxt: '入住',
    checkOutTxt: '离店',
    checkInDate: '入住日期',
    checkOutDate: '离店日期',
    Frequenter: '常客',
    Temporary: '临客',
    TemporaryInformation: '临客信息',
    addFrequenter: '添加常客',
    addTemporary: '添加临客',
    TravelStandard: '差旅标准',
    hightToLow: '从高到低',
    lowToHight: '从低到高',
    morningToNight: '从早到晚',
    nightToMorning: '从晚到早',
    starLevelTxt: '星级',
    filtrateTxt: '筛选',
    timeTxt: '时间',
    fromTo: '起',
    portion: '份',
    contactNumber: '联系电话',
    conformToRules: '符合规则',
    breakToRules: '违背规则',
    unlimited: '不限',
    beforeDay: '前一天',
    afterDay: '后一天',
    adequateTxt: '充足',
    Remaining: '仅剩',
    taxesTxt: '税费',
    BackTorule: '退改规则',
    trainamendrule: '对开车前15天(不含)以上退票的，不收取退票费。票面乘车站开车前48小时以上的，退票时收取票价5%的退票费;开车前24小时以上、不足48小时的，退票时收取票价10%的退票费;开车前不足24小时的，退票时收取票价20%退票费。',
    booking: '订',
    onlinePay: '在线付',
    departTxt: '出发',
    arrivalTxt: '到达',
    sheet: '张',
    NoTicket: '无票',
    orderFilltitle: '订单填写',
    tripInfosTitle: '出行人信息',
    BookingInformation: '预订须知',
    tripInfosRemarks: '为了您顺利出行，请务必保证填写项与出游所持证件一致',
    addTraveller: '添加旅客',
    UserName: '姓名',
    contactInfosTitle: '联系人信息',
    RemarkInfosTitle: '备注信息',
    contacts: '联系人',
    Phone: '手机',
    Email: '电子邮件',
    InstructTitle: '扣款说明',
    InstructContent: '会根据您的付款方式进行预授权或扣除房费，如订单不确认将解除预授权或全额退款至您的付款账户。该订单确认后不可被取消修改，若未入住将收取您首日房费，如提前离店将扣除提前离店当天的费用。',
    SpecialTipsTitle: '特别提示',
    SpecialTipsContent: '该酒店的入住时间为14:00，退房标准结算时间为12:00。如 提前入住或推迟离店，均须酌情加收一定的费用。',
    travelInformationTitle: '差旅信息',
    CostCenter: '成本中心',
    TravelPurpose: '差旅目的',
    ProjectCode: '项目代码',
    contraryReason: '违背原因',
    ViolateTravelRules: '违背差旅规则',
    SpecialRequirement: '特殊需求',
    SpecialRequirementTips: '特殊需求备注',
    specialRequirementContent: '你的特殊要求，我们会尽量协调。如无法满足，我们不会 另行通知，请您见谅。',
    otherRequirement: '其他需求',
    consentAgreement: '点击提交表示已阅读并同意',
    importantTerms: '预订须知和重要条款',
    BookingHint: '为支持绿色环保,默认电子合同,若需要签订纸质合同请致电客服。',
    CostDetails: '费用明细',
    payTotalPrice: '应付总额',
    totalPrice: '总额',
    roomUnit: '房',
    nightUnit: '夜',
    peopleUnit: '人',
    details: '明细',
    CustomerService: '联系客服',
    SubmissionOrPayment: '提交/支付',
    frequentlnformationTitle: '旅客信息',
    TravellerTitle: '旅客姓名',
    EnglishName: '英文姓名',
    LastName: '英文姓',
    firstName: '英文名',
    NameOrIdCardTips: '为了确保顺利出行，请确保出行姓名与证件保持一致。',
    CertificateInformatTitle: '证件信息',
    ExpireDate: '证件有效期',
    otherInfosTitle: '其他信息',
    Sex: '性别',
    Birthday: '出生日期',
    Nationality: '国籍',
    optionalCard: '旅客卡（选填）',
    reminderInfos: '为了你能顺利出行，请确保旅行结束日期至少比证件有效期早6个月，并确认填写真实、有效的证件号码，订单提交后将无法修改',
    addOrEditTraveller: '添加编辑旅客',
    AllOrder: '全部订单',
    orderStatus: '订单状态',
    departTime: '出发时间',
    orderDetail: '订单详情',
    CancelOrder: '取消订单',
    CancelRefund: '取消退票',
    CancelChange: '取消改签',
    ApprovalRefused: '审批拒绝',
    ApproveSucc: '审批通过',
    PayNow: '立即支付',
    Refund: '退票',
    RefundHotel: '退房',
    RefundGroup: '退团',
    Change: '改签',
    SubmitOrder: '提交订单',
    PriceDetail: '价格详情',
    CheckOrderProgress: '查看订单进度',
    flightInformation: '航班信息',
    orderNumber: '订单号',
    BookingTime: '预订时间',
    First: '第',
    Journey: '程',
    few: '间',
    Level: '级',
    BackToChangeTips: '最终金额以审核为准，如有疑问请拨打客服电话',
    pleaseChoose: '请选择',
    ThePassengers: '的旅客',
    Transfer: '经停',
    Flight: '航班',
    RefundRoomsDate: '退房入住时间',
    TheReason: '的原因',
    TheTrain: '的车次',
    hour: '小时',
    minute: '分钟',
    Gym: '健身房',
    district: '行政区',
    business: '商业区',
    ThePassengerInformation: '旅客信息',
    NewTrainInformation: '新车次信息',
    OriginalTrainInformation: '原车次信息',
    NewFlightInformation: '新航班信息',
    OriginalFlightInformation: '原航班信息',
    NextStep: '下一步',
    ChangeDate: '改签日期',
    SelectChangeFlight: '请选择改签的航班',
    SelectRefundFlight: '请选择退票的航班',
    SelectChangeTrain: '请选择改签的旅客',
    SelectRefundTrain: '请选择退票的旅客',
    SelectRefundHotel: '请选择退房的酒店',
    SelectChangeDate: '请选择改签日期',
    Department: '部门',
    ApprovalStatus: '审批状态',
    ConfidentialInformation: '凭证信息',
    TradeInformation: '交易信息',
    Insurance: '保险',
    Home: '首页',
    Stroke: '行程',
    Me: '我的',
    TravelApproval: '差旅审批',
    TravelRulesName: '差旅规则名称',
    MinimumPriceBase: '最低价格基准',
    RealFlightControl: '实时航班管控',
    AdvanceBookingTime: '提前预订时间',
    ClassLimit: '舱位级别限制',
    SeatClassLimit: '座位级别限制',
    AgreementAirlinePriority: '协议机票优先',
    AgreementHotelPriority: '协议酒店优先',
    MaximumAmountConsumption: '消费金额上限',
    ApprovalName: '审批名称',
    Other: '其他',
    FirstClassCity: '一级城市',
    SecondaryCity: '二级城市',
    ThreeLevelCity: '三级城市',
    SeatSelectionService: '选座服务',
    Bezel: '窗',
    Aisle: '过道',
    NewContacts: '新增联系人',
    AdditionalInvoiceInformation: '新增/编辑发票信息',
    InvoiceInformation: '发票信息',
    InvoiceTitle: '发票抬头',
    TariffItem: '税号',
    SetDefaultContacts: '设置默认联系人',
    ConsigneeAddress: '收件地址',
    NewCommonAddresses: '新增常用地址',
    default: '默',
    City: '城市',
    Address: '地址',
    Postcode: '邮编',
    AddCommonAddresses: '新增/编辑常用地址',
    DepartureTime: '起飞时间',
    Airport: '机场',
    ShippingSpace: '舱位',
    AirlineCompany: '航空公司',
    '150OrLess': '￥150以下',
    '150And300': '￥150-300',
    '300And450': '￥300-450',
    '450And600': '￥450-600',
    '600OrMore': '￥600以上',
    TwoStarsOrLess: '二星及以下',
    ThreeStar: '三星级/舒适',
    FourStar: '四星级/高档',
    FivesStar: '五星级/豪华',
    Apartment: '公寓',
    Inn: '客栈',
    FamilyInn: '家庭旅馆',
    YouthHostel: '青年旅舍',
    CoupleHotel: '情侣酒店',
    GardenCourtyard: '园林庭院',
    SeaView: '海景',
    Farmhouse: '农家乐',
    HotSpringHotel: '温泉酒店',
    GolfHotel: '高尔夫酒店',
    Siheyuan: '四合院',
    Villa: '别墅',
    PartyCooking: '聚会做饭',
    BusinessTtravelHome: '商旅之家',
    LeisureMood: '休闲情调',
    SeeDoctor: "看病就医",
    VacationLeisure: "度假休闲",
    TrainAndLearn: "培训学习",
    GetTogether: "聚会",
    HoneymoonTrip: "蜜月出行",
    boutiqueHotel: "精品酒店(设计师酒店)",
    FreeWifi: "免费wifi",
    FreeParking: "免费停车场",
    IndoorPool: "室内游泳池",
    OutdoorPool: "室外游泳池",
    service: "健身房",
    BusinessCenter: "商务中心",
    MeetingRoom: "会议室",
    HotelRestaurant: "酒店餐厅",
    MorningCall: "叫醒服务",
    LuggageStorage: "行李寄存",
    TwinBed: "双床",
    BigBed: "大床",
    FreePickUpService: "免费接机服务",
    Price: '价格',
    StarLevel: '星级',
    Specialtie: '特色',
    Service: '设施服务',
    DetailsOrFacilities: '详情/设施',
    HotelDetail: '酒店详情',
    ModelSelection: '机型选择',
    HighSpeedRail: '高铁(G/C)',
    MotorCar: '动车(D)',
    Ordinary: '普通(Z/T/K)',
    DepartureOrArrival: '出发/到达车站'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Service', '服务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Date', '日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Status', '状态'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'OldSystem', '请使用PC版查看'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Welcome', '欢迎您'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'PleaseLogIn', '请登录'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'FlightTips', '低价机票，舒适出行'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'HotelTips', '尊享入住，商旅独享'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'TrainTips', '一键闪电出票'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'TourTips', '精选特价旅游'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Invoice', '发票抬头'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'InvoiceType', '发票类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Identifier', '识别号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'TicketInquiry', '机票查询'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'TrainInquiry', '火车查询'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'HotelInquiry', '酒店查询'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ConsumerHotline', "客服电话"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'WeChatService', "微信客服"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'TravelPolicy', '差旅政策'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'EditData', '编辑资料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'RecommendFlight', '推荐航班'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'OriginalFlight', '原航班'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'More', '更多'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'MoreInfo', '更多信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Hidden', '隐藏'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'JetFuel', '含机建燃油'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Booking', '预订'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'CurrentPosition', '当前位置'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Room', '房间'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'SquareMeters', '平米'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'CanLive', '可住'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Floor', '楼层'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Layer', '层'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ServiceFee', '服务费'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'InsurancePremium', '保险费'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Yuan', '元'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ContactHotel', '联系酒店'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'After', '后'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Before', '前'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'For', '为'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'DueTo', '预订于'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ViolationPolicy', '违背政策'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'CompliancePolicy', '符合政策'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'BusinessInformation', '商旅信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Within', '以内'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'RefuseReason', '审批备注'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Against', '违背了'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Policy', '的政策'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'DetailedReason', '详情原因'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Wait', '等待'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Approval', '审批'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Breach', '违背'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'AirlineAuditStandards', '以航空公司最新规定为准，可咨询客服电话'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ConfirmOrder', '确认订单'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'FlightInformation', '航程信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Voyage', '航程'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'DeparturePlace', '出发地点'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ArrivePlace', '到达到点'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'AddVoyage', '添加航程'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'PassengersNumbers', '乘客人数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ShipType', '舱位类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'PassengersType', '乘客类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ShipCompany', '首选航司'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Remarks', '备注'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'PackUp', '收起'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Show', '展开'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'DocumentType', '证件类型'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'CardNo', '证件号码'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'InvoiceRole', '发票角色'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'BankName', '银行名称'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'BankAccount', '银行账号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'RegisteredAddress', '注册地址'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'RegisteredPhone', '注册电话'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ChangeReason', '改签原因'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'VoucherNumber', '凭证号'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'CancelReason', '取消原因'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ChildInfantBooking', '儿童婴儿预订说明'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'BookingInformation', '预订信息'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'boyin', '波音'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'kongke', '空客'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'AppropriationBudget', '经费预算'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Attendance', '参会人数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'HostPlace', '举办地点'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Destination', '目的地'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ParticipantsNumber', '参加人数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ActivityBudget', '活动预算'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'AmountPaid', '需要支付金额'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'ConfirmPayment', '确认支付'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'Pay', '付'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, 'PriceTxt', '价'), _mall),
  placeholders: {
    contacts: '请填写联系人姓名',
    Email: '用于接收确认单',
    CostCenter: '请选择成本中心',
    TravelPurpose: '请选择差旅目的',
    ProjectCode: '请填写项目代码',
    CauseName: '请选择违背原因',
    CauseDetails: '请填写详细违背原因',
    searchTraveller: '请输入姓名',
    SearchZones: '城市、车站的中文或拼音',
    UserName: '与证件姓名一致',
    LastName: '如：张飞，填：ZHANG',
    firstName: '如：张飞，填：FEI',
    CardNo: '所持证件号码',
    Phone: '请输入手机号码',
    RecipientAddress: '请输入收件人地址',
    RecipientPostcode: '请输入收件人邮编',
    OriginalPassword: '请输入原密码',
    Password: '请输入密码',
    NewPassword: '请输入新密码',
    AffirmNewPassword: '请确认密码',
    CompanyName: '请输入企业名称',
    SelectCity: '请选择城市',
    Industry: '请输入行业',
    Account: '请输入手机号或邮箱',
    VerificationCode: '请输入验证码',
    DynamicCode: '请输入动态码',
    RegisterPhone: '请注册或绑定手机号！',
    Invoice: '发票抬头',
    InvoiceType: '发票类型',
    Identifier: '必填，纳税人识别号',
    UserID: '请输入账户',
    RefusalCause: '请输入拒绝原因',
    CaseInsensitive: '不区分大小写',
    MessageAuthenticationCode: '短信验证码',
    DeparturePlace: '出发地点',
    ArrivePlace: '到达到点',
    ContactEmail: '请输入邮箱',
    Remarks: '请输入备注',
    ShipCompany: '首选航司',
    BankName: '银行名称',
    BankAccount: '银行账号',
    RegisteredAddress: '注册地址',
    RegisteredPhone: '注册电话',
    TrainDetailReason: '火车详情原因',

    PeopleNumber: '请输入人数',
    AppropriationBudget: '请输入预算经费',
    ContactNumber: '请输入联系电话',
    ContactRemarks: '告诉我们您最方便的联系时间及方式，让我们在最恰当的时间回复您。'
  },
  system: {
    EmailNotification: '邮件通知',
    servicePhone: '400-088-8020',
    Company: '力程商旅',
    Name: '力程商旅',
    contacts: '联系信息',
    HowToCall: '大家该怎么称呼您',
    PerfectInformation: '请完善手机号码',
    BindingPhone: '绑定手机',
    BindingEmail: '绑定邮箱',
    AccountAssociated: '账号关联',
    UpdatePassword: '修改登录密码',
    Language: '语言',
    Chinese: '中',
    English: '英',
    ExitLogin: '退出登录',
    WeChat: '微信',
    ImmediatelyBinding: '立即绑定',
    Password: '密码',
    OriginalPassword: '原密码',
    NewPassword: '新密码',
    AffirmNewPassword: '确认密码',
    ChangePassword: '修改密码',
    EditPersonalInformation: '编辑个人资料',
    CompanyName: '企业名称',
    Industry: '行业',
    Account: '账户',
    VerificationCode: '验证码',
    DynamicCode: '动态码',
    RegisterNow: '立即注册',
    Register: '注册',
    UserRegister: '个人注册',
    CompanyRegister: '企业注册',
    ServiceAgreement: '同意《力程旅行网服务协议》',
    SendDynamicCode: '发送动态码',
    Sent: '已发送',
    LoginTxt: '登录',
    DynamicPasswordLogin: '动态密码登录',
    ForgetPassword: '忘记密码',
    Integral: '积分',
    AllOrders: '全部订单',
    Obligation: '待付款',
    NotToTravel: '未出行',
    ToApproval: '待审批',
    TicketInformation: '票证信息',
    OrderInformation: '订单信息',
    OrderID: '订单编号',
    TradeID: '交易编号',
    TradeAmount: '订单总金额',
    CollectingCompany: '收款公司',
    PaymentWays: '支付方式',
    Payment: '支付',
    ThePassengerInformation: '旅客信息',
    PassWordLogin: '密码登录',
    CodeLogin: '验证码登录',
    Notice: '通知',
    RecentOrders: '近期行程',
    Reserved: '待订妥',
    CustomerService: '客服',
    Sell: '销售',
    ContactUs: '联系我们',
    Call: '呼叫',
    ServiceDept: '客服部',
    MyOrder: '我的订单',
    ApprovalDispose: '审批处理',
    RetrievePwd: '便于登录或找回密码',
    ElectronicBills: '便于接收电子账单',
    ApprovalAccredit: '审批授权',
    AboutUs: '关于我们',
    TestGetCode: '获取验证码',
    PhoneHint: '您可以通过有效的绑定手机重置密码。',
    EmailHint: '您可以通过有效的绑定邮箱重置密码。',
    LoginPassword: '登录密码',
    ResetPassword: '重置密码',
    EnterAccount: '输入账号',
    PhoneVerification: '手机验证',
    EmailVerification: '邮箱验证',
    SetBinding: '设置绑定',
    Input: '输入',
    Effective: '有效的',
    Verify: '验证',
    NextStep: '下一步',
    RemarkString: '退改签时限',
    RefundFee: '退票费',
    Cabinfee: '同舱改期费',
    ReimburseInfo: '报销信息',
    BaggageAllowance: '行李额',
    BackChangeRemark: '以上成人退改签规则及费用标准，仅供参考，实际需以航司为准.',
    PartRoute: '部分航线',
    PartHotel: '部分酒店',
    IsSaveCustomers: '是否保存常客',
    EmployeeRights: '员工权限',
    DateGranted: '授予日期',
    ExpiryDate: '过期日期',
    AddApproval: '添加/修改审批',
    AddApprovals: '添加审批',
    DownloadInstall: '下载安装',
    TopRightCorner: '请点击右上角',
    BrowserOpen: '选择"浏览器中打开"',
    CannotDownloaded: '微信/QQ内无法下载应用',
    CompanyProfile: '公司概况',
    CompanyProfileContent: '上海力程官网(www.lichengtrip.net)隶属于上海力程票务有限公司，公司总部设在中国上海，总部办公地点位于上海市长宁区新东纺国际商务中心，紧临静安寺曹家渡等商务中心地段，内设呼叫中心、总经办、财务部、票务结算部、国际部、国内同行部、客户服务部、培训部、商务部、运营中心等相应部门。是上海销售范围较广、服务规模较大、综合实力较强的大型民航服务企业。',
    FutureProspects: '未来前景',
    FutureProspectsContent: '在互联网技术迅猛发展的21世纪，上海力程联合科研单位研发的商旅分销系统，用具有独立知识产权的先进技术，以方便快捷的流线型工程服务于天下民众生活的方方面面，让每一个生活在网络社会的普通百姓，都有机会成为网络经济大潮的弄潮儿。使他们在分分秒秒的网络生活体验中，感受到中华民族优秀传统文化和现代民主生活方式的完美融合，感受到实实在在的人文关爱和物质生活的不断丰富与提升，为推动网络社会健康、和谐、稳定发展，奉献出力程人的全部热情和智慧!2016年是力程迎来更高发展的时刻，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
    ManagementTeam: '紧密精进的管理团队',
    ManagementTeamContent: '上海力程的管理团队在资源合作、管理技能、业务经验上的完美组合，以及团队间紧密贴切的合作保证了公司迅速稳健的发展。我们的高层管理团队集合了国际IT业、旅游业及金融业多年业务运作与管理的经验；中层管理团队汇集了中国IT业、航空代理业及旅游业的，保证了服务规模化和资源规模化的管理方针。',
    TechnicalService: '技术领先与服务',
    TechnicalServiceContent: '力程一直将技术创新视为企业的活力源泉，在提升研发能力方面不遗余力。力程建立了一整套现代化服务系统，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、酒店预订、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
    AboutUsContent: '电话：400-088-8020'
  },
  share: {
    hot: '热门',
    calendarDataTitle: '选择日期',
    calendarDataExplain: '查询日期为出发日期',
    cancelTxt: "取消",
    confirmTxt: "确定",
    pullUpLoadMoreTxt: '加载更多',
    pullUpLoadNoMoreTxt: '没有更多',
    RefreshTheSuccess: '刷新成功',
    Save: '保存',
    Add: '添加',
    QueryBtn: '查询',
    SubmitBtn: '提交',
    AmendBtn: '修改',
    FinishBtn: '完成',
    fail: {
      CancelOrder: '请选择取消订单',
      RefundOrder: '请选择取消退票订单',
      selectTraveller: '请选择旅客！',
      minPrice: '您选择不是推荐航班或舱位，确定要继续预订？',
      CostCenter: '请输入成本中心！',
      TravelPurpose: '请输入差旅目的！',
      EnglishName: '该乘客没有英文名称！',
      RefundJourney: '请选择您需要退票的行程！',
      RefundReason: '请选择您需要退票的原因！',
      RefundTraveller: '请选择您需要退票的旅客！',
      ChangeJourney: '请选择您需要改签的行程！',
      ChangeTraveller: '请选择您需要改签的旅客！',
      ChooseAnotherFlight: '请选择其他航司的航班！',
      TheCorrectName: '请输入正确的姓和名！',
      UsreNameRepetition: '乘客名不能重复！',
      RegisterPhone: '请注册或绑定手机号！',
      VerificationCode: '请输入验证码',
      DynamicCode: '请输入动态码',
      PassengerSurname: '请输入旅客姓',
      PassengerName: '请输入旅客名',
      RefusalCause: '请填写拒绝原因！',
      PhoneBinding: '绑定的手机号不能空',
      EmailBinding: '绑定的邮箱不能空',
      Phone: '请输入正确的手机号',
      Email: '请输入正确的邮箱',
      VerificationTime: '每隔60s才能获取一次验证码',
      Account: '请输入账号',
      AccountEmpty: '账号不能为空',
      PasswordEmpty: '密码不能为空',
      PassengersNumbers: '旅客数量已上限,请联系客服',
      ManyPeople: '人数过多,请联系客服进行团购',
      ChangeReason: '改签原因不能为空',
      SeatNumbers: '乘客人数超过选择座位数',
      SelectSeat: '请为已选择的旅客选择座位'
    },
    succ: {
      SaveSucc: '保存成功！',
      CancelSucc: '取消成功！',
      ApprovalRefused: '审批拒绝！',
      ApproveSucc: '审批通过！',
      RefundSucc: '退票申请提交成功',
      ChangeSucc: '改签申请提交成功！',
      RegisteredSucc: '注册成功！',
      LoginSucc: '登陆成功！',
      ChangePasswordSucc: '密码修改成功',
      VerificationSucc: '验证码发送成功',
      AddSucc: '添加成功',
      ModifySucc: '修改成功',
      DeleteSucc: '删除成功',
      WeChat: '微信解绑成功'
    },
    confirm: {
      YesOrNoDelect: '是否确认删除',
      CreateOrder: '订单创建成功，欢迎您随时在订单详细中关注订单进度',
      ThankRemarks: '感谢您长期以来对力程商旅的信任与支持，为了更好提升用户差旅体验，力程商旅2018年10月30日上午9点起正式上线力程商旅2.0系统。用户可通过App Store自动更新, 安卓系统请联系本公司客服咨询，紧急联络电话15901610043。谢谢！'
    },
    loading: {
      load: '努力加载中',
      creatOrder: '订单创建中',
      PriceCalculation: '价格计算中'
    }
  },
  Categorys: (_Categorys = {
    Young: '成人',
    Enfant: '儿童',
    Infant: '婴儿',
    economyClass: '经济舱',
    buissenesClass: '商务舱',
    firstClass: '头等舱',
    OnBusiness: '因公',
    OnPersonal: '因私',
    FlightService: '机票',
    HotelService: '酒店',
    TourService: '旅游',
    TrainService: '火车',
    SingleVoyage: '单程',
    RoundVoyage: '往返',
    WaitBooking: '待预订',
    WaitConfirm: '待确认',
    WaitPayment: '待支付',
    WaitDispose: '待处理',
    Finished: '已完成',
    Canceled: '已取消',
    Rejected: '已退回',
    Cannot: '暂不能',
    WaitApprove: '待审批',
    Discrete: '已拆分',
    WaitSubmit: '待提交',
    WaitRefund: '待退款',
    Male: '男',
    Female: '女',
    IDCard: "身份证",
    PassportCard: "护照",
    StudentCard: "学生证",
    OfficerCard: "军官证",
    HKMpermit: "港澳通行证",
    TaiWpermit: "台湾通行证",
    OtherCard: "其它",
    Company: '公司',
    User: '用户',
    HotelFare: '房费',
    TicketFare: '票面',
    MobileAuth: '手机账号',
    EmailAuth: '邮箱账号',
    AccountAuth: '账号密码',
    WeixinAuth: '微信授权',
    DynamicAuth: '动态密码',
    MessageNotify: '短信通知',
    MailNotify: '邮件通知',
    WechatNotify: '微信通知',
    AppNotify: 'App通知',
    Normal: '普通',
    OverseasStudent: '学生',
    Worker: '劳务',
    Immigrant: '新移民',
    '1138Categorys': '身份证',
    '1139Categorys': '护照',
    '1140Categorys': '学生证',
    '1141Categorys': '军官证',
    '1298Categorys': '港澳通行证',
    '1299Categorys': '台湾通行证',
    '1142Categorys': '其它'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'Finished', "已完成"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendingFlight', '部分退票中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeingFlight', '部分改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendingTrain', '部分退票中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeingTrain', '部分改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendingHotel', '部分退房中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeingHotel', '部分改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendingTour', '部分退团中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeingTour', '部分改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendedFlight', '部分退票'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeedFlight', '部分改签'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendedTrain', '部分退票'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeedTrain', '部分改签'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendedHotel', '部分退房'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeedHotel', '部分改签'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AmendedTour', '部分退团'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'ChangeedTour', '部分改签'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendingFlight', '退票中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeingFlight', '改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookingFlight', '购票中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendingTrain', '退票中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeingTrain', '改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookingTrain', '购票中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendingHotel', '退房中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeingHotel', '改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookingHotel', '预订中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendingTour', '退团中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeingTour', '改签中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookingTour', '预订中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendedFlight', '退票成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeedFlight', '改签成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookedFlight', '购票成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendedTrain', '退票成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeedTrain', '改签成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookedTrain', '购票成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendedHotel', '退房成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeedHotel', '改签成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookedHotel', '预订成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllAmendedTour', '退团成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllChangeedTour', '改签成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, 'AllBookedTour', '预订成功'), _Categorys),
  RegExp: {
    AccountReg: {
      isEmpty: '账户不能空',
      isFormat: '账户格式不正确'
    },
    PwdReg: {
      isEmpty: '密码不能空',
      isFormat: '密码格式不正确'
    },
    ConfigPwd: {
      isEmpty: '密码不能空',
      isFormat: '密码不一致'
    },
    VerificationCodeReg: {
      isEmpty: '验证码不能空'
    },
    DynamicCodeReg: {
      isEmpty: '动态码不能空'
    },
    ProtocolReg: {
      isFlag: '必须遵守协议'
    }
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _mall, _system, _Categorys;

/* harmony default export */ __webpack_exports__["a"] = ({
  mall: (_mall = {
    allprice: "full price",
    discount: "Dis",
    GivenName: 'Given Name',
    Surname: 'Surname',
    selectedseat: 'Select',
    noselectseat: 'Unselect',
    takeOff: 'Take Off',
    FillInfo: 'Fill Info',
    ExpiryDate: 'ExpiryDate',
    StartTime: "Starting time",
    EndTime: "End Time ",
    ToProcessDate: "Departure date",
    backTracking: "Return date",
    sharing: "Share",
    AirplaneModelTxt: "Airplane model",
    ticketfeeFloat: "This price does not include airrax, fuel and tax",
    peopleTypeExplain: "Booking instruction for children and infants",
    bookingTicketExplain: "If you are booking a child/infant ticket for public needs, please contact our customer service.",
    onlySeeDirect: "Only direct flights",
    hiddenSharedFlight: "Hide shared flights",
    ActualCarrier: "Actual carrier",
    stayTxt: "Stay",
    turnTxt: "Transit",
    priceRemarks: 'The following fees are per capita for "1 adult or 1 child or 1 infant"',
    AgreementPrice: "Agreement",
    tax: "Tax",
    trainHolderKeyWords: "Domestic train ticket",
    bookingRemarks: "Can only book up to 5 passengers at a time",
    beginTxt: "departure station ",
    passTxt: "passing by",
    endTxt: "destination ",
    StandingOrder: "Num",
    stationName: "Name",
    arrivalTimeTxt: "Arrival",
    departTimeTxt: "Depart",
    departDate: "Depart date",
    arrivalDate: "Arrival date",
    hotelHolderKeyWords: "Please enter a keyword/hotel name, etc.",
    HotelRemarks: "Please do not exceed 5 rooms with living time not more than 20 nights. For special reservations, please contact our customer service.",
    TrainRemarks: "Tips: The ticket purchase time is 7:30 - 22:30. Ticket purchase, change and refund must be no later than 30 minutes before the start of the trip. Please pay within 10 minutes for trips within the day. Please pay within 25 minutes for trips beyond 24 hours.",
    NoTrainSearch: "No train inquiry service is available during the current time",
    mapTxt: "map / navigation ",
    detailsOrFacilities: "Details / Facilities",
    noSooner: "None Breakfast",
    breakfast: "Breakfast",
    breakfastTxt: "Including breakfast",
    noCancellation: "Cannot cancel",
    timeToCancel: "Cancel within a time limit",
    RoomsTxt: "Room Number",
    hotelUnit: "night",
    checkInTxt: "Check in",
    checkOutTxt: "check out",
    checkInDate: "Check-in date",
    checkOutDate: "check-out date",
    Frequenter: "Frequent guest",
    Temporary: "temporary guest",
    TemporaryInformation: "temporary guest info",
    addFrequenter: "Add frequent guest",
    addTemporary: "Add temporay guest",
    TravelStandard: "Business trip standard",
    hightToLow: "From high to low",
    lowToHight: "From low to high",
    morningToNight: "Morning Till Night",
    nightToMorning: "From late to early",
    starLevelTxt: "Star",
    filtrateTxt: "Filter",
    timeTxt: "Time",
    fromTo: "From",
    portion: "Share",
    contactNumber: "Contact",
    conformToRules: "Conform",
    breakToRules: "Violating rules",
    unlimited: "Unlimited",
    beforeDay: "the day before ",
    afterDay: "the day after ",
    adequateTxt: "Sufficient",
    Remaining: "Only left",
    taxesTxt: "Tax",
    BackTorule: "Refund/Chang ",
    booking: "Book",
    onlinePay: "Pay",
    departTxt: "Set off ",
    arrivalTxt: "Arrive",
    sheet: "pcs",
    NoTicket: "None",
    orderFilltitle: "Fill order",
    tripInfosTitle: "Traveler Info",
    BookingInformation: "Booking Info",
    tripInfosRemarks: "In order to travel smoothly, please ensure that the items filled in are consistent with the documents held.",
    addTraveller: "Add passenger",
    UserName: "Name",
    contactInfosTitle: "Contact Info",
    RemarkInfosTitle: "Remarks",
    contacts: "Contact person",
    Phone: "Mobile",
    Email: "Email",
    InstructTitle: "Deduction instructions",
    InstructContent: "Pre-authorization or deduction of the room rate will be based on your payment method. If the order is not confirmed, the pre-authorization will be released or a full refund will be made to your payment account. This order cannot be cancelled after confirmation. If you do not check in, your first day room rate will be charged. If you check out early, the fee for the day you leave will be deducted.",
    SpecialTipsTitle: "Special Note ",
    SpecialTipsContent: "The hotel's check-in time is 14:00 and the standard check-out time is 12:00. If you check in early or postpone your check-out, you will be charged a fee as appropriate.",
    travelInformationTitle: "Travel info",
    CostCenter: "CostCenter",
    TravelPurpose: "Purpose",
    ProjectCode: "Code",
    contraryReason: "Reason",
    ViolateTravelRules: "Violate travel rules",
    SpecialRequirement: "Special needs",
    SpecialRequirementTips: "Special needs",
    specialRequirementContent: "We will try our best to coordinate your special needs. If we are unable to do that, there will be no further notice.",
    otherRequirement: "other needs",
    consentAgreement: "Click Submit to indicate that you have read and agreed",
    importantTerms: "Booking instructions and important terms",
    BookingHint: "To support the green environmental protection, we adopt default electronic contract, if you need to sign a paper contract, please call customer service.",
    CostDetails: "Charge Details ",
    payTotalPrice: "Total",
    totalPrice: "Total",
    roomUnit: "Room",
    nightUnit: 'night',
    peopleUnit: "People",
    details: "Detail",
    CustomerService: "Contact Customer Service ",
    SubmissionOrPayment: "Submit/pay",
    frequentlnformationTitle: "Passenger",
    TravellerTitle: "Passenger Name ",
    EnglishName: "English name ",
    LastName: "English last name",
    firstName: "English fisrst name ",
    NameOrIdCardTips: "In order to ensure smooth travel, please ensure that the travel name is consistent with the certificate.",
    CertificateInformatTitle: "Certificate Info ",
    ExpireDate: "Validity of cetficiate",
    otherInfosTitle: "Other Info ",
    Sex: "Sex",
    Birthday: "Birthday",
    Nationality: "Nationality",
    optionalCard: "Passenger card (optional)",
    reminderInfos: "In order to travel smoothly, please ensure that the travel end date is at least 6 months earlier than the validity period of the certficiate and confirm to fill in true and valid ID number, which will not be modified after the order is submitted.",
    addOrEditTraveller: "Add/Edit travelers",
    AllOrder: "All orders",
    orderStatus: "Status",
    departTime: "Depart time",
    orderDetail: "Order detail ",
    CancelOrder: "Cancel order ",

    CancelRefund: 'Cancel refund',
    CancelChange: 'Cancel change',
    ApprovalRefused: "Rejected ",
    ApproveSucc: "Approved ",
    PayNow: "Pay immediately ",
    Refund: "Refund",
    RefundHotel: "RefundHotel",
    RefundGroup: 'RefundGroup',
    Change: "Change",
    SubmitOrder: "Submit orders",
    PriceDetail: "Price detail",
    CheckOrderProgress: "View order progress",
    flightInformation: "flight information ",
    orderNumber: "Order number ",
    BookingTime: "Book Time",
    First: "No.",
    Journey: "Schedule",
    few: "Room",
    Level: "Level",
    BackToChangeTips: "The final amount is subject to the review. If you have any questions, please call customer service.",
    pleaseChoose: "please choose ",
    ThePassengers: "Traveler",
    Transfer: "Transit",
    Flight: "Flight",
    RefundRoomsDate: "Check-out and check-in time",
    TheReason: "reason for ",
    TheTrain: "Number of train",
    hour: "Hour",
    minute: "Minute",
    Gym: 'Gym',
    district: 'District',
    business: 'Business',
    ThePassengerInformation: "Passenger information",
    NewTrainInformation: "New train information",
    OriginalTrainInformation: "Original train information",
    NewFlightInformation: "New flight information",
    OriginalFlightInformation: "Original flight information",
    NextStep: "Next step",
    ChangeDate: "Change date",
    SelectChangeFlight: "Please select the changed flight",
    SelectRefundFlight: "Please select the refunded flight",
    SelectChangeTrain: "Please select the changed passenger",
    SelectRefundTrain: "Please select the passenger who refunds",
    SelectRefundHotel: "Please select the hotel for refund",
    SelectChangeDate: "Please select the date of change",
    Department: "Department",
    ApprovalStatus: "Status",
    ConfidentialInformation: "Voucher",
    TradeInformation: "Trading Info",
    Insurance: "Insurance Info",
    Home: "Home",
    Stroke: "Trip",
    Me: "My",
    TravelApproval: "Travel approval",
    TravelRulesName: "Travel rule name",
    MinimumPriceBase: "Lowest price benchmark",
    RealFlightControl: "Real-time flight control",
    AdvanceBookingTime: "Booking time in advance",
    ClassLimit: "Class level limit",
    SeatClassLimit: "Seat level limit",
    AgreementAirlinePriority: "Agreement ticket priority",
    AgreementHotelPriority: "Agreement hotel priority",
    MaximumAmountConsumption: "Maximum amount of consumption",
    ApprovalName: "Approval name",
    Other: "Other",
    FirstClassCity: "Primary city",
    SecondaryCity: "Secondary city",
    ThreeLevelCity: "Tertiary city",
    SeatSelectionService: "Seat selecting service",
    Bezel: "window",
    Aisle: "Aisle",
    NewContacts: "Add contact person",
    AdditionalInvoiceInformation: "Add/edit invoice Info",
    InvoiceInformation: "Invoice Information ",
    InvoiceTitle: "Rise",
    TariffItem: "Tax number",
    SetDefaultContacts: "Set default contact person",
    ConsigneeAddress: "Recipient Address ",
    NewCommonAddresses: "Add a common address",
    default: "default",
    City: "City",
    Address: "Address",
    Postcode: "Zip code",
    AddCommonAddresses: "Add/edit common addresses",
    DepartureTime: "departure time ",
    Airport: "Airport",
    ShippingSpace: "Cabin",
    AirlineCompany: "Airline",
    '150OrLess': "￥150 or more",
    '150And300': "￥150-300",
    '300And450': "￥300-450",
    '450And600': "￥450-600",
    '600OrMore': "￥600 or more",
    TwoStarsOrLess: "Two stars and below",
    ThreeStar: "Three stars/comfortable",
    FourStar: "Four stars/high-end",
    FivesStar: "Five stars/luxury",
    Apartment: "apartment",
    Inn: "inn",
    FamilyInn: "family hotel",
    YouthHostel: "youth hostel",
    CoupleHotel: "love hotel",
    GardenCourtyard: "garden courtyard",
    SeaView: "seaview",
    Farmhouse: "agritainment",
    HotSpringHotel: "hot spring hotel",
    GolfHotel: "golf hotel",
    Siheyuan: "quadrangle courtyard?",
    Villa: "villa",
    PartyCooking: "cooking party",
    BusinessTtravelHome: "business trip home",
    LeisureMood: "recreational feeling",
    SeeDoctor: "hospital",
    VacationLeisure: "holiday leisure",
    TrainAndLearn: "training and learning",
    GetTogether: "party",
    HoneymoonTrip: "honeymoon trip",
    boutiqueHotel: "boutique hotel",
    FreeWifi: "free wifi",
    FreeParking: "free parking lot",
    IndoorPool: "indoor swimming pool",
    OutdoorPool: "outdoor swimming pool",
    service: "gym",
    BusinessCenter: "business center",
    MeetingRoom: "meeting room",
    HotelRestaurant: "hotel restaurant",
    MorningCall: "wakeup call",
    LuggageStorage: "luggage deposit",
    TwinBed: "double bed",
    BigBed: "big bed",
    FreePickUpService: "free pickup service",
    Price: "Price",
    StarLevel: "Star",
    Specialtie: "Features",
    Service: "Service",
    DetailsOrFacilities: "Details/Facilities",
    HotelDetail: "Hotel details",
    ModelSelection: "Model selection",
    HighSpeedRail: "High-speed rail (G/C)",
    MotorCar: "EMU (D)",
    Ordinary: "Normal (Z/T/K)",
    DepartureOrArrival: "Departure/arrival station",
    Date: "Date",
    Status: "State",
    OldSystem: "Please use view on PC version",
    Welcome: "Welcome ",
    PleaseLogIn: "please log in ",
    FlightTips: "Cheap flight, comfortable trip",
    HotelTips: "Exclusive business trip",
    TrainTips: "Fast ticketing with one click",
    TourTips: "Featured Special Travel",
    Invoice: "Rise",
    InvoiceType: "Type",
    Identifier: "identification number ",
    TicketInquiry: "Ticket inquiry",
    TrainInquiry: "Train inquiry",
    HotelInquiry: "Hotel inquiry",
    ConsumerHotline: "consumer hotline ",
    WeChatService: "WeChat customer service",
    TravelPolicy: "Travel policy",
    EditData: "Edit Info",
    RecommendFlight: "Recommend",
    OriginalFlight: "Original flight",
    More: "More ",
    Hidden: "Hide",
    JetFuel: "Airrax、fuel",
    Booking: "Book",
    CurrentPosition: "current position ",
    Room: "room",
    SquareMeters: "square meter",
    CanLive: "tenantable",
    Floor: "floor",
    Layer: "layer",
    ServiceFee: "Service fee",
    InsurancePremium: "Insurance fee",
    Yuan: "Yuan",
    ContactHotel: "Contact hotel",
    After: "after",
    Before: "Before",
    For: "For",
    DueTo: "Due to",
    ViolationPolicy: "Violation policy",
    CompliancePolicy: "Compliance policy",
    BusinessInformation: "Business Info",
    Within: "Within",
    RefuseReason: "Reason",
    Against: "Violate",
    Policy: "Policy",
    DetailedReason: "Reason details",
    Wait: "Waiting",
    Approval: "Approval",
    Breach: "Violation",

    AirlineAuditStandards: "In accordance with the latest regulations of the airline, customer service telephone number can be consulted",
    ConfirmOrder: "Confirm Order ",
    FlightInformation: "Flight Info",
    Voyage: "Flight",
    DeparturePlace: "Departure place ",
    ArrivePlace: "Arrive place",
    AddVoyage: "Add a voyage",
    PassengersNumbers: "Number of passengers",
    ShipType: "Class type",
    PassengersType: "Passenger Type ",
    ShipCompany: "Preferred airline",
    Remarks: "Remarks",
    PackUp: "PackUp",
    Show: "Expand",
    DocumentType: "CardID",
    CardNo: "CardNo",
    InvoiceRole: "Role",
    BankName: "Bank name ",
    BankAccount: "Bank Account",
    RegisteredAddress: "Registered address",
    RegisteredPhone: "Registered phone",
    ChangeReason: "Reason for change",
    VoucherNumber: "Voucher ID",
    CancelReason: "Reason for Cancellation ",
    ChildInfantBooking: "Booking instruction for children and infants"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "BookingInformation", 'Booking Info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "boyin", "Boeing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "kongke", "Airbus"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AppropriationBudget", 'Appropriation Budget'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Attendance", '参会人数'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "HostPlace", 'Host Place'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Destination", 'Destination'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ParticipantsNumber", 'Participants Number'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ActivityBudget", 'Activity Budget'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "AmountPaid", 'Amount to be paid'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "ConfirmPayment", 'Confirm Payment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "Pay", 'Pay'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mall, "PriceTxt", 'Price'), _mall),
  placeholders: {
    contacts: "Please fill in the contact person's name",
    Email: "Required to fill to receive confirmation",
    CostCenter: "Please select a cost center",
    TravelPurpose: "Please choose the purpose of travel",
    ProjectCode: "Please fill in the project code",
    CauseName: "Please choose the reason for the violation",
    CauseDetails: "Please fill in the detailed reason for violation",
    searchTraveller: "Please enter your name ",
    SearchZones: "Chinese or pinyin of city or station",
    UserName: "Consistent with the number on the caerrtificate",
    LastName: "For example: Zhang Fei, fill: ZHANG",
    firstName: "For example: Zhang Fei, fill: FEI",
    CardNo: "ID number",
    Phone: "Please enter the phone number ",
    RecipientAddress: "Please enter the recipient address",
    RecipientPostcode: "Please enter the recipient zip code",
    OriginalPassword: "Please enter the original password",
    Password: "Please enter your password",
    NewPassword: "Please enter a new password ",
    AffirmNewPassword: "Please confirm your password ",
    CompanyName: "Please enter the company name",
    SelectCity: "Please select city ",
    Industry: "Please enter the industry",
    Account: "Please enter your mobile number or email address",
    VerificationCode: "please enter verification code ",
    DynamicCode: "Please enter a dynamic code",
    RegisterPhone: "Please register or bind your mobile number!",
    Invoice: "Invoice ",
    InvoiceType: "invoice type ",
    Identifier: "Required to fill taxpayer identification number",
    UserID: "Please enter an account",
    RefusalCause: "Please enter the reason for rejection",
    CaseInsensitive: "not case sensitive ",
    MessageAuthenticationCode: "SMS verification code ",
    DeparturePlace: "Departure place ",
    ArrivePlace: "Arrive place",
    ContactEmail: "please enter your email ",
    Remarks: "Please enter a note",
    ShipCompany: "Preferred airline",
    BankName: "Bank name ",
    BankAccount: "Bank Account ",
    RegisteredAddress: "Registered address ",
    RegisteredPhone: "Registered phone",
    TrainDetailReason: "Train detailed reason",
    PeopleNumber: 'Please enter number',
    AppropriationBudget: 'Please enter the budget',
    ContactNumber: 'Please enter your contact number',
    ContactRemarks: 'Let us know your most convenient contact time and way, so that we can reply to you at the most appropriate time.'
  },
  system: (_system = {
    EmailNotification: 'Email Notify',
    servicePhone: '400-088-8020',
    contacts: "Contact"
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "servicePhone", '400-088-8020'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Company", 'Licheng'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Name", 'Licheng'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "HowToCall", "How to call you?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PerfectInformation", "Please complete your mobile number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "BindingPhone", "bound phone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "BindingEmail", "bound mailbox"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AccountAssociated", "Account association"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "UpdatePassword", "Modify the login password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Language", "Language"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Chinese", "CN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "English", "EN"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ExitLogin", "Logout"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "WeChat", "WeChat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ImmediatelyBinding", "Bind immediately"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Password", "Password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "OriginalPassword", "old password "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "NewPassword", "new password "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AffirmNewPassword", "confirm password "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ChangePassword", "change Password "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "EditPersonalInformation", "Edit Profile"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CompanyName", "Company Name "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Industry", "Industry"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Account", "Account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "VerificationCode", "Verification code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DynamicCode", "Dynamic code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RegisterNow", "Register"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Register", "Register"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "UserRegister", "Personal registration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CompanyRegister", "Company registration"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ServiceAgreement", "Agree to Service Agreement of Licheng Travel Network "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SendDynamicCode", "Send dynamic code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Sent", "Has been sent "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LoginTxt", "Login "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DynamicPasswordLogin", "login with dynamic password "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ForgetPassword", "Forget password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Integral", "integral"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AllOrders", "All orders"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Obligation", "Paid "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "NotToTravel", "Not Travelled"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ToApproval", "Approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TicketInformation", "Ticket Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "OrderInformation", "Order Info "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "OrderID", "ID"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TradeID", "Transaction number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TradeAmount", "The total amount of order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CollectingCompany", "Receivable Company "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PaymentWays", "Payment method "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Payment", "Pay"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ThePassengerInformation", "Passenger Info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PassWordLogin", "Login by account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CodeLogin", "Login by dynamic code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Notice", "Notice "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RecentOrders", "Recent trip"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Reserved", "Ordered"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CustomerService", "Customer service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Sell", "Sales "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ContactUs", "Contact us "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Call", "Call"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ServiceDept", "Customer Service Department"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "MyOrder", "My Order "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ApprovalDispose", "Approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RetrievePwd", "Easy to log in or retrieve password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ElectronicBills", "Easy to receive electronic bills"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ApprovalAccredit", "Approval and authorization"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AboutUs", "About us"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TestGetCode", "Verification"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PhoneHint", "You can reset your password with a valid bound phone."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "EmailHint", "You can reset your password with a valid bound mailbox."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "LoginPassword", "login password "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ResetPassword", "reset password "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "EnterAccount", "enter account "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PhoneVerification", "Phone verification "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "EmailVerification", "E-mail verification "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "SetBinding", "Set binding"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Input", "Enter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Effective", "Valid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Verify", "Verify"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "NextStep", "Next step"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RemarkString", "Time limit for changing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "RefundFee", "Fee for refund "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "Cabinfee", "Same-class rescheduling fee"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ReimburseInfo", "Reimbursement information"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "BaggageAllowance", "Baggage allowance"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "BackChangeRemark", "The above rules for adult refund and change and fees are for reference only, subject to airline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PartRoute", "Partial route"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "PartHotel", "Parial hotels"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "IsSaveCustomers", "Whether to save frequent passenger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "EmployeeRights", "Employee authority"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DateGranted", "Date of grant"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ExpiryDate", "Expiration date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AddApproval", "Add/modify approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AddApprovals", "Add approval"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "DownloadInstall", "Download and install "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TopRightCorner", "Please click on the top right corner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "BrowserOpen", "Select to open in browser"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CannotDownloaded", "Unable to download app in WeChat/QQ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CompanyProfile", "Company Overview "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "CompanyProfileContent", "Shanghai Licheng official website (www.lichengtrip.net) is affiliated to Shanghai Licheng Ticketing Co., Ltd. The company is headquartered in Shanghai, China. The office is located in Xindongfang International Business Center in Changning District, Shanghai, close to Jing'an Temple Caojiadu and other business centers. It has a call center, general management office, finance department, ticket settlement department, international department, domestic counterpart department, customer service department, training department, commercial department, operation center and other corresponding departments. It is a large-scale civil aviation service enterprise with wide sales scope, large service scale and strong comprehensive strength in Shanghai."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "FutureProspects", "Future prospects "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "FutureProspectsContent", "In the 21st century with rapid development of Internet technology, the business travel distribution system developed by Shanghai Licheng and research units uses advanced technology with independent intellectual property rights to facilitate the streamlined engineering and serve the ordinary people in the world. It makes every ordinary people living in the network society have the opportunity to become a palyer in the tide of the Internet economy, so that in the network life of every minute and second, they experience the perfect integration of the excellent traditional culture of the Chinese nation and the modern democratic lifestyle, feel the tangible humanistic care and the continuous enrichment and enhancement of material life, to contribute all the enthusiasm and wisdom of Licheng people to the promotion of the healthy, harmonious and stable development of the network society! In 2016, Licheng ushers in higher development. We will take innovation and enterprising as motive, further accelerate the development speed and improve the development quality, take international and domestic air ticket sales as the mainstay and also develop vacation bookings, and implement a comprehensive development strategy to promote informationization and build an information platform."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ManagementTeam", "Close enterprising management team"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "ManagementTeamContent", "The perfect combination of the management teams of Shanghai Licheng in resource cooperation, management skills, business experience and close cooperation between among teams ensure the rapid and steady development of the company. Our senior management team brings together many years of experience in operations and management of international IT, tourism and finance industries; the middle management team brings together China's IT industry, aviation agency industry and tourism industry, ensuring the management policy of service scale and resource scale."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TechnicalService", "Technology leadership and service"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "TechnicalServiceContent", "Licheng has always regarded technological innovation as a source of vitality for the company and spared no effort in improving its research and development capabilities. Licheng has established a set of modern service system with innovation and enterprising as the driving force, to further accelerate the development speed and improve the development quality. With international and domestic ticket sales as the mainstay, we also develop hotel reservations and vacation reservations, and implement a comprehensive development strategy to promote informationization and build an information platform."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_system, "AboutUsContent", 'tel：400-088-8020'), _system),
  share: {
    hot: "#",
    calendarDataTitle: "Select date",
    calendarDataExplain: "The inquired date is the departure date",
    cancelTxt: "Cancel",
    confirmTxt: "Confirm",
    pullUpLoadMoreTxt: "load more ",
    pullUpLoadNoMoreTxt: "no more ",
    RefreshTheSuccess: "Refresh successfully",
    Save: "Save",
    Add: "Add",
    QueryBtn: "Search",
    SubmitBtn: "Submit",
    AmendBtn: "Modify",
    FinishBtn: "Complete",
    fail: {
      CancelOrder: 'Please choose to cancel the order',
      RefundOrder: 'Please choose to cancel the refund order',
      selectTraveller: "Please choose a passenger!",
      minPrice: "You are not selecting the recommended flight or class, confirm to continue booking?",
      CostCenter: "Please enter the cost center!",
      TravelPurpose: "Please enter your travel purpose!",
      EnglishName: "The passenger does not have an English name!",
      RefundJourney: "Please select the itinerary you need to refund!",
      RefundReason: "Please select the reason for refund!",
      RefundTraveller: "Please select the passenger you need to refund!",
      ChangeJourney: "Please select the itinerary you need to change!",
      ChangeTraveller: "Please select the passenger you need to change!",
      ChooseAnotherFlight: "Please select a flight from another airline!",
      TheCorrectName: "Please enter the correct first name and last name!",
      UsreNameRepetition: "The passenger name cannot be repeated!",
      RegisterPhone: "Please register or bind your mobile number!",
      VerificationCode: "please enter verification code ",
      DynamicCode: "Please enter a dynamic code",
      PassengerSurname: "Please enter the passenger's last name",
      PassengerName: "Please enter the passenger's first name",
      RefusalCause: "Please fill in the reason for rejection!",
      PhoneBinding: "The bound phone number cannot be blank",
      EmailBinding: "The bound mailbox cannot be blank",
      Phone: "please enter a correct phone number ",
      Email: "please enter a correct emailbox",
      VerificationTime: "Get a verification code every 60s",
      Account: "Please enrer account",
      AccountEmpty: "Account cannot be blank",
      PasswordEmpty: "password can not be blank ",
      PassengersNumbers: "The number of passengers has been capped, please contact customer service",
      ManyPeople: "Too many people, please contact customer service for group purchase.",
      ChangeReason: "The reason for the change cannot be blank",
      SeatNumbers: "The number of passengers exceeds the number of seats selected",
      SelectSeat: "Please select a seat for the selected passenger"
    },
    succ: {
      SaveSucc: "Successfully saved!",
      CancelSucc: "Successfully cancelled!",
      ApprovalRefused: "Rejected!",
      ApproveSucc: "Approved!",
      RefundSucc: "Refund application submitted successfully",
      ChangeSucc: "The application for the change is submitted successfully!",
      RegisteredSucc: "Register successfully!",
      LoginSucc: "Log in successfully!",
      ChangePasswordSucc: "Password modified successfully!",
      VerificationSucc: "The verification code is sent successfully.",
      AddSucc: "Added successfully ",
      ModifySucc: "Modified successfully ",
      DeleteSucc: "Deleted successfully ",
      WeChat: 'WeChat unbound successfully'
    },
    confirm: {
      YesOrNoDelect: "Confirm to delete?",
      CreateOrder: "The order is created successfully, please keep an eye on the order progress in the order details at any time.",
      ThankRemarks: "Thank you for your long-term trust and support for Licheng Business Travel. In order to better enhance the user's travel experience, Licheng Business Travel officially launches Licheng Business Travel 2.0 system from 9:00 am on October 30, 2018. Users can automatically update through in App Store. For Android system, please contact our customer service and contact the emergency number 15901610043. Thank you!"
    },
    loading: {
      load: "Try to load. . .",
      creatOrder: "The order is being created. . .",
      PriceCalculation: "Price calculating..."
    }
  },
  Categorys: (_Categorys = {
    Young: "Adult",
    Enfant: "Child",
    Infant: "Infant",
    economyClass: "Economic class",
    buissenesClass: "Business class",
    firstClass: "First class",
    OnBusiness: "Public",
    OnPersonal: "Private",
    FlightService: "Flight",
    HotelService: "Hotel",
    TourService: "Travel",
    TrainService: "Train",
    SingleVoyage: "One way ",
    RoundVoyage: "Round trip ",
    WaitBooking: "To be booked",
    WaitConfirm: "to be confirmed ",
    WaitPayment: "Paid ",
    WaitDispose: "To be processed ",
    Finished: "completed ",
    Canceled: "Cancelled ",
    Rejected: "Returned",
    Cannot: "Temporarily cannot",
    WaitApprove: "WaitApprove",
    Discrete: "Split",
    WaitSubmit: "To be submiited",
    WaitRefund: "To be refunded",
    Male: "Male",
    Female: "Female ",
    IDCard: "IDCard",
    PassportCard: "Passport",
    StudentCard: "Student card ",
    OfficerCard: "Military officer card",
    HKMpermit: "Exit-Entry Permit for Travelling to and from Hong Kong and Macao ",
    TaiWpermit: "Travel Permit for Mainlanders to Enter and Exit Taiwan",
    OtherCard: "Other",
    Company: "Company ",
    User: "User",
    HotelFare: "Room rate ",
    TicketFare: "Ticket face",
    MobileAuth: "Mobile",
    EmailAuth: "Email",
    AccountAuth: "account password ",
    WeixinAuth: "WeChat authorization",
    DynamicAuth: "dynamic password ",
    MessageNotify: "SMS notification",
    MailNotify: "E-mail notification ",
    WechatNotify: "WeChat notification",
    AppNotify: "App notification",
    Normal: 'Normal',
    OverseasStudent: 'Student',
    Worker: 'Worker',
    Immigrant: 'Immigrant',
    '1138Categorys': 'IDCard',
    '1139Categorys': 'Passport',
    '1140Categorys': 'Student',
    '1141Categorys': 'Officer',
    '1298Categorys': 'HKMpermit',
    '1299Categorys': 'TaiWpermit',
    '1142Categorys': 'Other'
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "Finished", "Finished"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "Amended", 'Part Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "Amending", 'Part Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "Changeing", 'Part Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "Changeed", 'Part Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmending", 'Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeing", 'Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBooking", 'Booking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmended", 'Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeed", 'Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBooked", 'Booked'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendingFlight", 'Part Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeingFlight", 'Part Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendingTrain", 'Part Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeingTrain", 'Part Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendingHotel", 'Part Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeingHotel", 'Part Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendingTour", 'Part Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeingTour", 'Part Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendedFlight", 'Part Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeedFlight", 'Part Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendedTrain", 'Part Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeedTrain", 'Part Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendedHotel", 'Part Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeedHotel", 'Part Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AmendedTour", 'Part Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "ChangeedTour", 'Part Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendingFlight", 'Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeingFlight", 'Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookingFlight", 'Booking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendingTrain", 'Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeingTrain", 'Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookingTrain", 'Booking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendingHotel", 'Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeingHotel", 'Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookingHotel", 'Booking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendingTour", 'Amending'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeingTour", 'Changeing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookingTour", 'Booking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendedFlight", 'Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeedFlight", 'Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookedFlight", 'Booked'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendedTrain", 'Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeedTrain", 'Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookedTrain", 'Booked'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendedHotel", 'Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeedHotel", 'Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookedHotel", 'Booked'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllAmendedTour", 'Amended'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllChangeedTour", 'Changeed'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Categorys, "AllBookedTour", 'Booked'), _Categorys),
  RegExp: {
    AccountReg: {
      isEmpty: "Account cannot be blank",
      isFormat: "Account format is incorrect"
    },
    PwdReg: {
      isEmpty: "Password cannot be blank",
      isFormat: "Password format is incorrect"
    },
    ConfigPwd: {
      isEmpty: "Password cannot be blank",
      isFormat: "Inconsistent password"
    },
    VerificationCodeReg: {
      isEmpty: "Verification code cannot be blank"
    },
    DynamicCodeReg: {
      isEmpty: "Dynamic code cannot be blank"
    },
    ProtocolReg: {
      isFlag: "Must comply with the agreement"
    }
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_modules_dialogs_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_modules_dialogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_modules_dialogs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_modules_globalLoad_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_modules_globalLoad_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_modules_globalLoad_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_modules_customer_services_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_modules_customer_services_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_modules_customer_services_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_flexible_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_flexible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_flexible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__language_index_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_zepto__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_zepto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filter_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_modules_keep_status_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_modules_keep_status_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_modules_keep_status_vue__);

















__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$api = __WEBPACK_IMPORTED_MODULE_5__apis__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.component("keep-status", __WEBPACK_IMPORTED_MODULE_13__views_modules_keep_status_vue___default.a);

var home = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].options.routes[0];
var historys = [{
  path: home.path,
  name: home.name
}];
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.getImgs = function (path, type) {
  var reg = /^app./g;
  var hostname = window.location.hostname;
  if (!reg.test(hostname) || hostname == "app.ecs.net") {
    hostname = 'app.lchtrip.com';
  }
  if (!type || type == 'img') {
    return "/static/" + hostname.replace(/\./g, '') + "/imgs/" + path;
  } else {
    return "url(/static/" + hostname.replace(/\./g, '') + "/imgs/" + path + ")";
  }
};


function isInView(target) {
  var bottom = target.getBoundingClientRect().bottom;

  if (window.innerHeight - bottom < 0) {
    return false;
  }
  return true;
}
var $window = __WEBPACK_IMPORTED_MODULE_11_zepto___default()(window);
var wHeight = $window.height();
__WEBPACK_IMPORTED_MODULE_11_zepto___default()(document).on("click", "[type=text],[type=password],textarea", function () {
  var $target = __WEBPACK_IMPORTED_MODULE_11_zepto___default()(event.target);
  var target = event.target;
  var i = 0;
  var ctl = setInterval(function () {
    if (!isInView(target)) {
      if (target.scrollIntoView) {
        target.scrollIntoView(false);
      } else {
        var height = $target.first().get(0).offsetTop;
        __WEBPACK_IMPORTED_MODULE_11_zepto___default()(".content").animate({
          scrollTop: height
        });
      }
    }
    i++;
    if (i > 5) clearInterval(ctl);
  }, 100);
});

function checkState(isTips, store, to, callback) {
  var requiresAuth = _.find(to.matched, function (o) {
    return o.meta.requiresAuth;
  });
  var isRedirect = requiresAuth !== undefined;
  if (document.cookie.indexOf("SfsSes") == -1 && !sessionStorage.getItem("SfsSes")) {
    callback(isRedirect);
    return;
  } else if (store.getters.ticketInfo.UserID !== undefined) {
    callback(false);
    return;
  }
  if (!isRedirect) {
    callback(false);
  }
  return store.dispatch("loadTicketInfo", {
    failTips: false
  }).then(function (response) {
    if (response.data.isSucc === true) {
      if (isRedirect) callback(false);
      return response;
    }
    return store.dispatch("logout").then(function () {
      if (isRedirect) callback(isRedirect);
    });
  }).catch(function (response) {
    if (isRedirect) callback(isRedirect);
  });
}

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
  var deviceInfo = localStorage.deviceInfo ? localStorage.deviceInfo : undefined;
  if (to.path == "/" && (!deviceInfo || deviceInfo == '{}')) {
    localStorage.setItem("deviceInfo", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(to.query));
  }
  checkState(false, __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */], to, function (isRedirect) {
    if (isRedirect === true) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
      return;
    }
    var lastHistory = historys[historys.length - 1];
    if (from.path == lastHistory.path) {
      lastHistory.scrollTop = __WEBPACK_IMPORTED_MODULE_11_zepto___default()(".page").scrollTop();
    }
    next();
  });
});
Date.prototype.toJSON = function () {
  return __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].DateFormat(this, "yyyy-MM-dd HH:mm:ss");
};

window.addEventListener("popstate", function (e) {
  console.log(e.state.target);
  if (e.state && e.state.target == "index") {
    window.history.pushState({ target: "index" }, "", "/");
  }
}, false);

var zeroWidthSpace = "\u200B";
var app = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  i18n: __WEBPACK_IMPORTED_MODULE_10__language_index_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */],
  data: function data() {
    return {
      transitionName: "slide-left",
      historys: [{
        path: home.path,
        name: home.name
      }],

      versionlist: {}
    };
  },

  computed: {
    lch_device_info: function lch_device_info() {
      if (window.lch_device_info) {
        return window.lch_device_info;
      } else {
        return undefined;
      }
    },
    keepAlive: function keepAlive() {
      var keepAlive = this.historys.map(function (router) {
        var str = (router.name || router.path).replace(/\//g, "");
        return str;
      }).join(",");
      return keepAlive;
    },
    FeatureCodes: function FeatureCodes() {
      var ticketInfo = this.$store.getters.ticketInfo || {};
      return (ticketInfo.FeatureCodes || []).map(function (o) {
        return o.toLowerCase();
      });
    },
    featureClasss: function featureClasss() {
      var _this = this;

      var clazz = [];
      if (window.lch_device_info != undefined) {
        clazz.push('appInner');
      }
      if (window.sessionStorage.FeatureCodes > -1) {
        clazz.push('HideHeader');
      }
      var doc = document;
      if (this.FeatureCodes.indexOf("hidelogo") > -1) {
        if (doc.title.length > 1) {
          doc.title = zeroWidthSpace;
        }
        clazz.push('hideLogo');
      } else {
        setTimeout(function () {
          if (_this.FeatureCodes.indexOf("hidelogo") == -1) {
            doc.title = title;
          }
        }, 5000);
      }
      if (this.FeatureCodes.indexOf("hidebtrip") > -1) {
        clazz.push('hideBtrip');
      }
      if (this.FeatureCodes.indexOf("hidelogs") > -1) {
        clazz.push('hideLogs');
      }
      return clazz.join(' ');
    }
  },
  watch: {
    $route: function $route(to, from) {
      var __self = this;

      var historys = __self.historys;
      var last = _.last(historys);
      if (last.fullPath == to.fullPath) return;
      var isBack = historys.length >= 2 && to.fullPath == _.first(_.takeRight(historys, 2)).fullPath;
      var isReplace = historys.length == 2 && _.startsWith(from.fullPath, to.fullPath);
      if (isBack || isReplace) {
        historys.pop();
      }
      if (!isBack || isReplace) {
        var length = history.length;
        var replaceBefore = _.find(historys, function (o) {
          return o.length == length && o.path == to.path;
        });
        if (!replaceBefore) {
          historys.push({
            path: to.path,
            name: name,
            fullPath: to.fullPath,
            length: length
          });
        } else {
          replaceBefore.fullPath = to.fullPath;
        }
      }
      __self.transitionName = isBack ? "slide-right" : historys.length > 2 ? "slide-left" : "";
    },
    '$i18n.locale': function $i18nLocale(newVal) {
      if (newVal) {
        this.SaveCookie(newVal);
      }
    }
  },
  created: function created() {
    var __self = this;
    __self.$api.base.gettripcomVersion({}).then(function (json) {
      if (json.data.isSucc) {
        __self.versionlist = json.data.result;
      }
    });
  },
  mounted: function mounted() {
    var __self = this;
    if (!window.sessionStorage.FeatureCodes) {
      window.sessionStorage.FeatureCodes = location.search.indexOf('HideHeader');
    }
    __self.SaveCookie(__self.$i18n.locale);
    __WEBPACK_IMPORTED_MODULE_11_zepto___default()(document).on("click", ".softKeyboardHide", function (e) {
      if (e.target.className.indexOf("softKeyboardHide") > -1) {
        document.activeElement.blur();
      }
    });
    __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* default */].dispatch("loadSiteInfo").then(function (json) {});
    __WEBPACK_IMPORTED_MODULE_11_zepto___default()("link[rel=icon]").attr("href", __self.getImgs('icon.ico'));
  },

  methods: {
    SaveCookie: function SaveCookie(value) {
      document.cookie = "lang=" + value + ";path=/;";
    }
  },
  components: {
    dialogs: __WEBPACK_IMPORTED_MODULE_2__views_modules_dialogs_vue___default.a,
    globalLoading: __WEBPACK_IMPORTED_MODULE_3__views_modules_globalLoad_vue___default.a,
    customerServices: __WEBPACK_IMPORTED_MODULE_4__views_modules_customer_services_vue___default.a
  }
}).$mount("#app");
__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].$app = app;
window.$app = app;

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    ZoneDatas: []
  },
  getters: {
    ZoneDatas: function ZoneDatas(state) {
      return state.ZoneDatas;
    }
  },
  mutations: {
    setZoneDatas: function setZoneDatas(state, ZoneDatas) {
      state.ZoneDatas = ZoneDatas;
    }
  },
  actions: {
    setZoneDatas: function setZoneDatas(_ref, ZoneDatas) {
      var commit = _ref.commit;

      commit('setZoneDatas', ZoneDatas);
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_categorys_js__ = __webpack_require__(96);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        categorys: __WEBPACK_IMPORTED_MODULE_0__utils_categorys_js__["a" /* default */]
    },
    getters: {
        categorys: function categorys(state) {
            return state.categorys;
        }
    },
    mutations: {},
    actions: {}
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_categorys_js__ = __webpack_require__(96);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    dialogConfig: {
      status: false,
      mess: '',
      title: '',
      buttons: []
    }
  },
  getters: {
    dialogConfig: function dialogConfig(state) {
      return state.dialogConfig;
    }
  },
  mutations: {
    setDialogConfig: function setDialogConfig(state, dialogConfig) {
      state.dialogConfig = dialogConfig;
    }
  },
  actions: {
    diologConfig: function diologConfig(_ref, dialogConfig) {
      var commit = _ref.commit;

      commit('setDialogConfig', dialogConfig);
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadConfig: {
      status: false,
      title: 'load'
    }
  },
  getters: {
    loadConfig: function loadConfig(state) {
      return state.loadConfig;
    }
  },
  mutations: {
    setLoadConfig: function setLoadConfig(state, loadConfig) {
      state.loadConfig = loadConfig;
    }
  },
  actions: {
    loadConfig: function loadConfig(_ref, _loadConfig) {
      var commit = _ref.commit;

      commit('setLoadConfig', _loadConfig);
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        siteInfo: {}
    },
    getters: {
        siteInfo: function siteInfo(state) {
            return state.siteInfo;
        }
    },
    mutations: {
        setSiteInfo: function setSiteInfo(state, siteInfo) {
            state.siteInfo = siteInfo;
        },
        removeSiteInfo: function removeSiteInfo(state) {
            state.siteInfo = {};
        }
    },
    actions: {
        removeSiteInfo: function removeSiteInfo(_ref) {
            var commit = _ref.commit;

            commit('removeSiteInfo');
        },
        loadSiteInfo: function loadSiteInfo(_ref2, UserID, CompanyID) {
            var commit = _ref2.commit;

            return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.getSiteInfo({
                failTips: false
            }).then(function (json) {
                if (!json.data.isSucc) {
                    return json;
                }

                commit('setSiteInfo', json.data.result);
            });
        }
    }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(95);


var cacheKey = 'loginState';
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loginState: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].cache(cacheKey),
    ticket: {}
  },
  getters: {
    isLogin: function isLogin(state) {
      return state.loginState;
    },
    ticketInfo: function ticketInfo(state) {
      return state.ticket;
    }
  },
  mutations: {
    loginSucc: function loginSucc(state) {
      state.loginState = true;
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].cache(cacheKey, true);
    },
    logoutSucc: function logoutSucc(state) {
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].cache(cacheKey, false);
      state.loginState = false;
      state.ticket = {};
    },
    setTicketInfo: function setTicketInfo(state, ticketInfo) {
      state.ticket = ticketInfo;
    }
  },
  actions: {
    logout: function logout(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.logout().then(function (response) {
        commit('logoutSucc');
        return response;
      }).catch(function () {
        commit('logoutSucc');
        return response;
      });
    },
    login: function login(_ref2, loginInfo) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.login(loginInfo).then(function (response) {
        if (response.data.isSucc) {
          commit('setTicketInfo', response.data.result);
          commit('loginSucc');
        }
        return response;
      });
    },
    loadTicketInfo: function loadTicketInfo(_ref3, options) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].system.getTicketInfo(options).then(function (response) {
        if (response.data.isSucc) {
          commit('setTicketInfo', response.data.result);
        }
        return response;
      });
    }
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utils = {};
utils.ErrorMessage = [];
utils.getTitle = function () {
  return undefined;
};
/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utils = {};
utils.RegExp = {
  MobileReg: /^1\d{10}$/,
  EmailReg: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/,
  PwdReg: /^[0-9]{8,16}$/,
  InvoiceReg: /^[\u4e00-\u9fa5]{0,50}$/,
  TaxNumReg: /^[A-Za-z0-9]{0,50}$/,
  NumberReg: /^[0-9]*$/ };
/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utils = {};
utils.Storage = window.sessionStorage;
utils.localStorage = window.localStorage;
/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var cacheUtils = {};
cacheUtils.cache = function (key, value) {
    if (value === undefined) return JSON.parse(localStorage.getItem(key));
    localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
};
/* harmony default export */ __webpack_exports__["a"] = (cacheUtils);

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var utils = {};
utils.clone = function (obj) {
    var o;
    switch (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) {
        case 'undefined':
            break;
        case 'string':
            o = obj + '';
            break;
        case 'number':
            o = obj - 0;
            break;
        case 'boolean':
            o = obj;
            break;
        case 'object':
            if (obj === null) {
                o = null;
            } else {
                if (obj instanceof Array) {
                    o = [];
                    for (var i = 0, len = obj.length; i < len; i++) {
                        o.push(utils.clone(obj[i]));
                    }
                } else {
                    o = {};
                    for (var k in obj) {
                        o[k] = utils.clone(obj[k]);
                    }
                }
            }
            break;
        default:
            o = obj;
            break;
    }
    return o;
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dateUtils = {};
dateUtils.DateFormat = function (date, fmt) {
    fmt = fmt ? fmt : "yyyy-MM-dd HH:mm:ss";
    var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "H+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds() };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }return fmt;
};
dateUtils.toTimeString = function (time, fmt) {
    var dTime = 60 * 60 * 24;
    var hTime = 60 * 60;
    var mTime = 60;
    var o = {
        "d+": Math.floor(time / dTime),
        "H+": Math.floor(time % dTime / hTime),
        "h+": Math.floor(time % dTime / hTime),
        "m+": Math.floor(time % dTime % hTime / mTime),
        "s+": Math.floor(time % dTime % hTime % mTime)
    };
    fmt = fmt ? fmt : "dd.HH:mm:ss";
    var isTrim = true;
    for (var k in o) {
        var iscTrim = false;
        if (isTrim) {
            if (o[k] != 0) {
                isTrim = false;
                iscTrim = true;
            }
        }
        if (!isTrim && iscTrim) {
            var rx = new RegExp("(" + k + ")").exec(fmt);
            if (rx != null && rx.length > 0) {
                fmt = fmt.substr(rx.index, fmt.length - rx.index);
            }
        }
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
    return fmt;
};
dateUtils.JsonToDate = function (jsonDate) {
    try {
        return new Date(parseInt(jsonDate.replace("/Date(", "").replace(")/", ""), 10));
    } catch (ex) {
        return "";
    }
};
dateUtils.JsonDateFormat = function (jsonDate, format) {
    return dateUtils.DateFormat(dateUtils.JsonToDate(jsonDate), format);
};
dateUtils.DateToString = function (date, format) {
    try {
        return dateUtils.DateFormat(date, format);
    } catch (ex) {
        return "";
    }
};
/* harmony default export */ __webpack_exports__["a"] = (dateUtils);

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex__);

var noticeUtils = {
  $app: null
};
noticeUtils.confirm = function (msg, buttonStatus, fn) {
  var __self = this;
  var dialogConfig = {
    buttons: []
  };
  if (buttonStatus == undefined) {
    dialogConfig.buttons.push({
      title: '',
      name: 'share.confirmTxt',
      affair: function affair() {
        dialogConfig.status = false;
        fn(true);
      }
    });
    dialogConfig.mess = msg;
    dialogConfig.status = true;
    __self.$app.$store.dispatch('diologConfig', dialogConfig);
    return;
  }
  dialogConfig.buttons.push({
    title: '',
    name: 'share.cancelTxt',
    affair: function affair() {
      dialogConfig.status = false;
      fn(false);
    }
  }, {
    title: '',
    name: 'share.confirmTxt',
    affair: function affair() {
      dialogConfig.status = false;
      fn(true);
    }
  });
  dialogConfig.mess = msg;
  dialogConfig.status = true;
  __self.$app.$store.dispatch('diologConfig', dialogConfig);
};
noticeUtils.fail = function (msg, types, fn) {
  var __self = this;
  var dialogConfig = {};
  if (types == 'fail' && fn == undefined) {
    dialogConfig.mess = msg;
    dialogConfig.status = true;
    dialogConfig.types = types;
    __self.$app.$store.dispatch('diologConfig', dialogConfig);
    setTimeout(function () {
      dialogConfig.status = false;
    }, 1000);
  }
};
noticeUtils.succ = function (msg, types, fn) {
  var __self = this;
  var dialogConfig = {};
  if (types == 'succ' && fn == undefined) {
    dialogConfig.mess = msg;
    dialogConfig.status = true;
    dialogConfig.types = types;
    __self.$app.$store.dispatch('diologConfig', dialogConfig);
    setTimeout(function () {
      dialogConfig.status = false;
    }, 1000);
  }
};
noticeUtils.Loading = {
  open: function open(title, BgColor) {
    var __self = $utils;
    var loadConfig = {
      status: true,
      title: title == undefined ? 'load' : title,
      BgColor: BgColor
    };
    __self.$app.$store.dispatch('loadConfig', loadConfig);
  },
  close: function close(title) {
    var __self = $utils;
    var loadConfig = {
      status: false,
      title: title == undefined ? 'load' : title
    };
    __self.$app.$store.dispatch('loadConfig', loadConfig);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (noticeUtils);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utils = {};
utils.extends = function (anyUtils) {
    for (var k in anyUtils) {
        utils[k] = anyUtils[k];
    }
};
utils.Group = function (strArr, fn) {
    var groups = {};
    if (fn == undefined) fn = function fn(item) {
        return item;
    };
    strArr.map(function (item) {
        var key = fn(item);
        var arr = groups[key];
        if (arr === undefined) {
            groups[key] = [];
            arr = groups[key];
        }
        arr.push(item);
    });
    return groups;
};
utils.PropertyToArray = function (obj) {
    var result = [];
    for (var key in obj) {
        var s = {};
        s["key"] = key;
        s["value"] = obj[key];
        result.push(s);
    }
    return result;
};
utils.each = function (arr, fn) {
    for (var i = 0; i < arr.length; i++) {
        fn(arr[i], i);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var stringUtils = {};
stringUtils.getLastTimeStr = function (time, isFromNow) {
    var date = new Date(time);
    var fmt = 'yyyy-MM-dd hh:mm';
    var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds() };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
};

stringUtils.append = function (_self, str) {
    return _self.concat(str);
};

stringUtils.deleteCharAt = function (_self, index) {
    if (index < 0 || index >= _self.length) {
        return _self.valueOf();
    } else if (index == 0) {
        return _self.substring(1, _self.length);
    } else if (index == _self.length - 1) {
        return _self.substring(0, _self.length - 1);
    } else {
        return _self.substring(0, index) + _self.substring(index + 1);
    }
};

stringUtils.deleteString = function (_self, start, end) {
    if (start == end) {
        return _self.deleteCharAt(start);
    } else {
        if (start > end) {
            var temp = start;
            start = end;
            end = temp;
        }
        if (start < 0) {
            start = 0;
        }
        if (end > _self.length - 1) {
            end = _self.length - 1;
        }
        return _self.substring(0, start) + _self.substring(end + 1, _self.length);
    }
};

stringUtils.endWith = function (_self, subStr) {
    if (subStr.length > _self.length) {
        return false;
    } else {
        return _self.lastIndexOf(subStr) == _self.length - subStr.length ? true : false;
    }
};

stringUtils.equal = function (_self, str) {
    if (_self.length != str.length) {
        return false;
    } else {
        for (var i = 0; i < _self.length; i++) {
            if (_self.charAt(i) != str.charAt(i)) {
                return false;
            }
        }
        return true;
    }
};

stringUtils.equalIgnoreCase = function (_self, str) {
    var temp1 = _self.toLowerCase();
    var temp2 = str.toLowerCase();
    return temp1.equal(temp2);
};

stringUtils.insert = function (_self, ofset, subStr) {
    if (ofset < 0 || ofset >= _self.length - 1) {
        return _self.append(subStr);
    }
    return _self.substring(0, ofset + 1) + subStr + _self.substring(ofset + 1);
};

stringUtils.isAllNumber = function (_self) {
    for (var i = 0; i < _self.length; i++) {
        if (_self.charAt(i) < '0' || _self.charAt(i) > '9') {
            return false;
        }
    }
    return true;
};

stringUtils.reserve = function (_self) {
    var temp = "";
    for (var i = _self.length - 1; i >= 0; i--) {
        temp = temp.concat(_self.charAt(i));
    }
    return temp;
};

stringUtils.setCharAt = function (_self, index, subStr) {
    if (index < 0 || index > _self.length - 1) {
        return _self.valueOf();
    }
    return _self.substring(0, index) + subStr + _self.substring(index + 1);
};

stringUtils.startWith = function (_self, subStr) {
    if (subStr.length > _self.length) {
        return false;
    }
    return _self.indexOf(subStr) == 0 ? true : false;
};

stringUtils.charLength = function (_self) {
    var temp = 0;
    for (var i = 0; i < _self.length; i++) {
        if (_self.charCodeAt(i) > 255) {
            temp += 2;
        } else {
            temp += 1;
        }
    }
    return temp;
};
stringUtils.charLengthReg = function (_self) {
    return _self.replace(/[^\x00-\xff]/g, "**").length;
};

stringUtils.trim = function (_self) {
    return _self.replace(/(^\s*)|(\s*$)/g, "");
};

stringUtils.isNumeric = function (_self) {
    var tmpFloat = parseFloat(this);
    if (isNaN(tmpFloat)) return false;
    var tmpLen = _self.length - tmpFloat.toString().length;
    return tmpFloat + "0".Repeat(tmpLen) == this;
};

stringUtils.isInt = function (_self) {
    if (this == "NaN") return false;
    return this == parseInt(this).toString();
};

stringUtils.Repeat = function (_self, num) {
    var tmpArr = [];
    for (var i = 0; i < num; i++) {
        tmpArr.push(this);
    }return tmpArr.join("");
};

stringUtils.resetBlank = function (_self) {
    return _self.replace(/s+/g, " ");
};

stringUtils.LTrim = function (_self) {
    return _self.replace(/^s+/g, "");
};

stringUtils.RTrim = function (_self) {
    return _self.replace(/s+$/g, "");
};

stringUtils.trim = function (_self) {
    return _self.replace(/(^s+)|(s+$)/g, "");
};

stringUtils.getNum = function (_self) {
    return _self.replace(/[^d]/g, "");
};

stringUtils.getEn = function (_self) {
    return _self.replace(/[^A-Za-z]/g, "");
};

stringUtils.getCn = function (_self) {
    return _self.replace(/[^u4e00-u9fa5uf900-ufa2d]/g, "");
};

stringUtils.getRealLength = function (_self) {
    return _self.replace(/[^x00-xff]/g, "--").length;
};

stringUtils.left = function (_self, n) {
    return _self.slice(0, n);
};

stringUtils.right = function (_self, n) {
    return _self.slice(_self.length - n);
};
/* harmony default export */ __webpack_exports__["a"] = (stringUtils);

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: "approvals",
  path: "/mall/approvals",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(568)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "flightBooking",
  path: "/mall/flight/booking",
  meta: {
    requiresAuth: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(569)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "flightList",
  path: "/mall/flight/list",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(571)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "demand",
  path: "/mall/:service/demand",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(576)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/flight/detail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(570)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "orderFill",
  path: "/mall/:state/orderFill",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(577)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "hotelBooking",
  path: "/mall/hotel/booking",
  meta: {
    requiresAuth: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(572)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/hotel/list",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(575)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "hotelDetail",
  path: "/mall/hotel/detail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(573)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/hotel/facility",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(574)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/hotel/map",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(219)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "trainBooking",
  path: "/mall/train/booking",
  meta: {
    requiresAuth: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(581)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/train/list",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(583)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/train/detail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(582)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "tourBooking",
  path: "/mall/tour/booking",
  meta: {
    requiresAuth: true
  },
  component: function component(resolve) {
    return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(580)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/addTraveller",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(588)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/oftenPassenger",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/system/oftenPassenger",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/AddTemporaryGuest",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(584)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "contacts",
  path: "/mall/contacts",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/system/contacts",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/system/address",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(220)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/address",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(220)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/addContact",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(586)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/invoice",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/system/invoice",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/addInvoice",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(587)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mall/specialRequirement",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(579)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "NewAddress",
  path: "/mall/NewAddress",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(585)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "selectTraveller",
  path: "/mall/selectTraveller",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(578)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: "DeviceInfo",
  path: "/DeviceInfo",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(567)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);

var _toString = Object.prototype.toString;

function isRegExp(v) {
  return _toString.call(v) === '[object RegExp]';
}

function isDef(v) {
  return v !== undefined && v !== null;
}

function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && isDef(c.componentOptions)) {
        return c;
      }
    }
  }
}

var patternTypes = [String, RegExp, Array];

function getComponentName(opts) {
  return opts && (opts.Ctor.options.name || opts.tag);
}

function matches(pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1;
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1;
  } else if (isRegExp(pattern)) {
    return pattern.test(name);
  }

  return false;
}

function pruneCache(cache, current, filter) {
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = key;
      if (name && !filter(name)) {
        if (cachedNode !== current) {
          pruneCacheEntry(cachedNode);
        }

        cache[key] = null;
      }
    }
  }
}

function pruneCacheEntry(vnode) {
  if (vnode) {
    vnode.componentInstance.$destroy();
    vnode.keepAlive = false;
  }
}

function GetDefaultComponentName(to) {
  return _.last(to.matched).components.default.name;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'm-keepalive',
  data: function data() {
    return {
      historys: []
    };
  },

  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes
  },

  created: function created() {
    this.cache = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);
  },
  destroyed: function destroyed() {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache[key]);
    }
  },
  mounted: function mounted() {
    if (this.historys.length == 0) {
      this.historys.push({
        path: '/',
        name: 'root',
        fullPath: '/'
      });
      var path = this.$route.path;
      if (this.$route.matched.length <= 0) {
        return;
      }

      var name = GetDefaultComponentName(this.$route);
      var __route = this.$route;
      this.historys.push({
        path: path,
        name: name,
        fullPath: __route.fullPath
      });
    }
  },


  watch: {
    include: function include(val) {},
    exclude: function exclude(val) {},
    '$route': function $route(to, from) {
      var historys = this.historys;
      var last = _.last(historys);
      if (last.fullPath == to.fullPath) return;

      var name = GetDefaultComponentName(to);
      var historyCount = historys.length;


      var keepAlive = historys.map(function (router) {
        return router.fullPath.replace(/[^\w|\d]/gi, '');
      }).join(',');

      if (historys.length != historyCount) {
        pruneCache(this.cache, this._vnode, function (name) {
          return matches(keepAlive, name);
        });
      }

      var isBack = historys.length >= 2 && to.fullPath == _.first(_.takeRight(historys, 2)).fullPath;
      var isReplace = historys.length == 2 && _.startsWith(from.fullPath, to.fullPath);
      if (isBack || isReplace) {
        historys.pop();
      }

      if (!isBack || isReplace) {
        historys.push({
          path: to.path,
          name: name,
          fullPath: to.fullPath
        });
      }
      keepAlive = historys.map(function (router) {
        return router.fullPath.replace(/[^\w|\d]/gi, '');
      }).join(',');
      if (to.fullPath == "/" || to.fullPath == "") {
        pruneCache(this.cache, this._vnode, function (name) {
          return name == "";
        });
      } else {
        pruneCache(this.cache, this._vnode, function (name) {
          return matches(keepAlive, name);
        });
      }
    }
  },

  render: function render() {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      var name = getComponentName(componentOptions);
      if (name && (this.include && !matches(this.include, name) || this.exclude && matches(this.exclude, name))) {
        return vnode;
      }

      var key = this.$route.fullPath.replace(/[^\w|\d]/gi, '');
      if (this.cache[key]) {
        vnode.componentInstance = this.cache[key].componentInstance;
      } else {
        this.cache[key] = vnode;
      }
      vnode.data.keepAlive = true;
    }
    return vnode;
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/order/all/list',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(594)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/detail',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(593)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/order/:service/:RuleType/:UniqueID',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(591)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mall/:service/ChangeInfos',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(592)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mall/hotel/map',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(219)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(566)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/calendar',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(565)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'selectCity',
  path: '/selectCity',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(590)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'WeChatCustomerCervice',
  path: '/WeChatCustomerCervice',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(589)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/system/rules/costCenter',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(604)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/rules/projectCode',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(605)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/rules/contraryReason',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(603)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/rules/travelPurpose',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(606)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/login',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/VerificationLogin',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(608)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/Register',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(607)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/businessRegister',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(614)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/user/main',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/user/account',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(610)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/user/editProfile',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(613)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/user/accountRelating',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(611)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/user/editPassword',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(612)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/system/user/notice',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(617)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/reset',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(618)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'BindingAccount',
  path: '/system/user/bindingAccount',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(609)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'approvalSetList',
  path: '/system/approvalSet/list',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(597)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'download',
  path: '/system/download',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(599)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'about',
  path: '/system/about',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(595)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'privacyPolicy',
  path: '/system/privacyPolicy',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(596)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'notify',
  path: '/system/notify',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(602)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'messageNotify',
  path: '/system/messageNotify',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(601)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'feedBack',
  path: '/system/feedBack',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(600)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  name: 'configInfo',
  path: '/system/configInfo',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(598)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/trade/cashier',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(619)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/trade/paySucc',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(620)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(72);


var _online;


/* harmony default export */ __webpack_exports__["a"] = ({
  online: (_online = {
    system: {
      prefix: "system"
    },
    order: {
      prefix: "order"
    },
    policy: {
      prefix: "policy"
    },
    bill: {
      prefix: "bill"
    },
    base: {
      prefix: "base"
    },
    tour: {
      prefix: "tour"
    },
    message: {
      prefix: "message"
    },
    flight: {
      prefix: "flight"
    },
    tourpolicy: {
      prefix: "tourpolicy"
    },
    flightpolicy: {
      prefix: "flightpolicy"
    },
    trainpolicy: {
      prefix: "trainpolicy"
    },
    hotelpolicy: {
      prefix: "hotelpolicy"
    },
    train: {
      prefix: "train"
    },
    hotel: {
      prefix: "hotel"
    },
    btrip: {
      prefix: "btrip"
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "btrip", {
    prefix: "btrip"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "work", {
    prefix: "work"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "insurancepolicy", {
    prefix: "insurancepolicy"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "fileUrl", {
    host: "images.ecsweb.jinyantrip.net",
    proxy: "images.ecsweb.jinyantrip.net",
    prefix: ""
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "chargepolicy", {
    prefix: "chargepolicy"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "side", {
    prefix: "side"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "admin", {
    prefix: "admin"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "logs", {
    prefix: "logs"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "storage", {
    prefix: "storage"
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_online, "huilianyi", {
    prefix: "huilianyi"
  }), _online),
  test: {
    system: {
      prefix: "system"
    },
    order: {
      prefix: "order"
    },
    policy: {
      prefix: "policy"
    },
    bill: {
      prefix: "bill"
    },
    base: {
      prefix: "base"
    },
    tour: {
      prefix: "tour"
    },
    message: {
      prefix: "message"
    },
    flight: {
      prefix: "flight"
    },
    tourpolicy: {
      prefix: "tourpolicy"
    },
    flightpolicy: {
      prefix: "flightpolicy"
    },
    trainpolicy: {
      prefix: "trainpolicy"
    },
    hotelpolicy: {
      prefix: "hotelpolicy"
    },
    train: {
      prefix: "train"
    },
    hotel: {
      prefix: "hotel"
    },
    btrip: {
      prefix: "btrip"
    },
    fileUrl: {
      host: "images.ecsweb.jinyantrip.net",
      proxy: "images.ecsweb.jinyantrip.net",
      prefix: ""
    },
    work: {
      prefix: "work"
    },
    insurancepolicy: {
      prefix: "insurancepolicy"
    },
    chargepolicy: {
      prefix: "chargepolicy"
    },
    side: {
      prefix: "side"
    },
    admin: {
      prefix: "admin"
    },
    logs: {
      prefix: "logs"
    },
    storage: {
      prefix: "storage"
    },
    adapter: {
      prefix: "adapter"
    },
    huilianyi: {
      prefix: "huilianyi"
    }
  },
  isOnline: false,
  isHttps: false,
  isProxy: false,
  getUrl: function getUrl(name, url) {
    var apicfg = this[this.isOnline ? "online" : "test"][name];
    var host = apicfg[this.isProxy ? "proxy" : "host"];
    var protocol = host ? this.isHttps ? "https" : "http" : "/api";
    if (host) {
      return protocol.concat("://", host, apicfg["prefix"] ? "/" : "", apicfg["prefix"], __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].startWith(url, "/") ? "" : "/", url);
    } else {
      return protocol.concat("/", apicfg["prefix"], __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].startWith(url, "/") ? "" : "/", url);
    }
  }
});

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(555),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(33)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.CompanyID) ? _c('div', {
    staticClass: "CustomerServices"
  }, [_c('div', {
    staticClass: "CustomerServices-wrapper",
    attrs: {
      "id": "CustomerServices"
    },
    on: {
      "touchstart": function($event) {
        return _vm.Touchstart($event)
      },
      "touchmove": function($event) {
        return _vm.Touchmove($event)
      },
      "touchend": function($event) {
        return _vm.Touchend($event)
      }
    }
  }, [_c('ul', {
    staticClass: "CustomerServices-item slidein-spring ",
    class: {
      'showFade': _vm.ShowFadeFlag, 'fadeBottom': _vm.isBottom
    }
  }, [_c('li', {
    staticClass: "CustomerServices-wrap"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.ShowFade($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/mascot.png"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "CustomerServices-list"
  }, [_c('li', {
    staticStyle: {
      "background": "#1CD49E"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/xiaoxi1.png"
    },
    on: {
      "click": _vm.messageNotify
    }
  })]), _vm._v(" "), _c('li', {
    staticStyle: {
      "background": "#FEAE00"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/feedBack-icon1.png"
    },
    on: {
      "click": _vm.ToFeedBack
    }
  })]), _vm._v(" "), _c('li', {
    staticStyle: {
      "background": "#B35CFF"
    }
  }, [_c('img', {
    attrs: {
      "id": "btn_udesk_im",
      "src": "/static/img/kefu4.png"
    },
    on: {
      "click": _vm.showUdesk
    }
  })])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "picker-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stateServices === 1),
      expression: "stateServices===1"
    }],
    staticClass: "picker",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": _vm.cancel
    }
  }, [_c('transition', {
    attrs: {
      "name": "picker-move"
    }
  }, [(_vm.stateServices === 1) ? _c('div', {
    staticClass: "picker-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "picker-choose border-bottom-1px"
  }, [_c('label', {
    on: {
      "click": _vm.cancel
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.14rem"
    },
    attrs: {
      "src": "/static/img/close.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "picker-title"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('system.CustomerService')) + "&" + _vm._s(_vm.$t('system.Sell')))])]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "0.13rem",
      "vertical-align": "text-top"
    },
    attrs: {
      "src": "/static/img/call.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "vertical-align": "text-top"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.ContactUs')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "picker-content",
    staticStyle: {
      "padding": "0 0.1rem"
    }
  }, _vm._l((_vm.Services), function(Service) {
    return (Service.ContactMobile != '') ? _c('div', {
      staticClass: "picker-item"
    }, [_c('div', [_c('span', {
      staticClass: "Service-UserName ellipsis"
    }, [_vm._v(_vm._s(Service.UserName))]), _vm._v(" "), _c('span', {
      staticClass: "Service-Type",
      staticStyle: {
        "vertical-align": "middle"
      },
      style: ({
        'background-color': Service.DepartmentName == _vm.$t('system.ServiceDept') ? '#d1edff' : '#ffe0cc',
        'color': Service.DepartmentName == _vm.$t('system.ServiceDept') ? '#17a5ff' : '#ff6600'
      })
    }, [_vm._v(_vm._s(Service.DepartmentName))])]), _vm._v(" "), _c('div', [_c('a', {
      attrs: {
        "href": ("tel:" + (Service.ContactMobile))
      }
    }, [_c('img', {
      staticStyle: {
        "width": "0.13rem",
        "vertical-align": "middle"
      },
      attrs: {
        "src": "/static/img/callb.png"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#666",
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm.$t('system.Call')))])])])]) : _vm._e()
  }), 0)]) : _vm._e()])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "explain-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === 1),
      expression: "state===1"
    }],
    staticClass: "explain",
    staticStyle: {
      "background": "rgba(255, 255, 255, .85)"
    },
    on: {
      "click": _vm.hide,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  })])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "list-wrapper"
  }, [_c('div', {
    staticClass: "scroll-content"
  }, [_c('div', {
    ref: "listWrapper",
    staticClass: "scroll-item"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pullup", [(_vm.pullUpLoad) ? _c('div', {
    staticClass: "pullup-wrapper"
  }, [(!_vm.isPullUpLoad) ? _c('div', {
    staticClass: "before-trigger"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.pullUpTxt)))])]) : _c('div', {
    staticClass: "after-trigger"
  }, [_c('loading')], 1)]) : _vm._e()], {
    "pullUpLoad": _vm.pullUpLoad,
    "isPullUpLoad": _vm.isPullUpLoad
  })], 2), _vm._v(" "), _vm._t("pulldown", [(_vm.pullDownRefresh) ? _c('div', {
    ref: "pulldown",
    staticClass: "pulldown-wrapper",
    style: (_vm.pullDownStyle)
  }, [(_vm.beforePullDown) ? _c('div', {
    staticClass: "before-trigger"
  }, [_c('bubble', {
    attrs: {
      "y": _vm.bubbleY
    }
  })], 1) : _c('div', {
    staticClass: "after-trigger"
  }, [(_vm.isPullingDown) ? _c('div', {
    staticClass: "loading"
  }, [_c('loading')], 1) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.refreshTxt)))])])])]) : _vm._e()], {
    "pullDownRefresh": _vm.pullDownRefresh,
    "pullDownStyle": _vm.pullDownStyle,
    "beforePullDown": _vm.beforePullDown,
    "isPullingDown": _vm.isPullingDown,
    "bubbleY": _vm.bubbleY
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "explain-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === 1),
      expression: "state===1"
    }],
    staticClass: "explain",
    on: {
      "click": _vm.cancel,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "explain-wrappper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    ref: "bubble",
    style: (_vm.style),
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadConfig.status) ? _c('div', {
    staticClass: "globalLoad",
    style: ({
      'background-color': _vm.loadConfig.BgColor ? _vm.loadConfig.BgColor : ''
    })
  }, [_c('div', {
    staticClass: "globalLoad-wrapper"
  }, [_c('div', {
    staticClass: "globalLoad-content"
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgs('loading1.gif')
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('share.loading.' + _vm.loadConfig.title)))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dialogConfig.status) ? _c('div', {
    staticClass: "dialog",
    class: {
      'dialogBG': _vm.dialogConfig.types != 'fail' && _vm.dialogConfig.types != 'succ' ? true : false
    }
  }, [(_vm.dialogConfig.types == 'fail' || _vm.dialogConfig.types == 'succ') ? _c('div', {
    staticClass: "fail"
  }, [_c('div', {
    staticClass: "dialog-content",
    class: {
      'failColor': _vm.dialogConfig.types == 'fail'
    }
  }, [_vm._v(_vm._s(_vm.dialogConfig.mess))])]) : _c('div', {
    staticClass: "dialog-wrapper"
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_vm._v(_vm._s(_vm.dialogConfig.mess))]), _vm._v(" "), _c('div', {
    staticClass: "border_bottom"
  }), _vm._v(" "), (_vm.dialogConfig.buttons.length > 1) ? _c('div', {
    staticClass: "dialog-btns"
  }, _vm._l((_vm.dialogConfig.buttons), function(button) {
    return _c('div', {
      on: {
        "click": button.affair
      }
    }, [_vm._v(_vm._s(_vm.$t(button.name)))])
  }), 0) : _c('div', {
    staticClass: "dialog-btn"
  }, _vm._l((_vm.dialogConfig.buttons), function(button) {
    return _c('div', {
      on: {
        "click": button.affair
      }
    }, [_vm._v(_vm._s(_vm.$t(button.name)))])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading.gif"
    }
  })])
}]}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "picker-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state === 1),
      expression: "state===1"
    }],
    staticClass: "picker",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": _vm.cancel
    }
  }, [_c('transition', {
    attrs: {
      "name": "picker-move"
    }
  }, [(_vm.state === 1) ? _c('div', {
    staticClass: "picker-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "picker-choose border-bottom-1px"
  }, [(_vm.hotelProduct && _vm.hotelProduct != '') ? _c('span', {
    staticClass: "productName"
  }, [_vm._v(_vm._s(_vm.hotelProduct.ProduceName))]) : _c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('share.confirmTxt')))])]), _vm._v(" "), _c('div', {
    staticClass: "picker-content"
  }, [_vm._t("default")], 2)]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports = VueI18n;

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateUtils__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringUtils__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noticeUtils__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cacheUtils__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneUtils__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objectUtils__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Storage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RegExp__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ErrorMessage__ = __webpack_require__(284);









__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_0__dateUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_1__stringUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_2__noticeUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_3__cacheUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_4__cloneUtils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_6__Storage__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_7__RegExp__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */].extends(__WEBPACK_IMPORTED_MODULE_8__ErrorMessage__["a" /* default */]);
window.$utils = __WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */];
window.statusCode = {
  Succ: 200,
  Fail: 400,
  Deny: 511,
  Error: 500
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__objectUtils__["a" /* default */]);

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var $http = {};

var tokens = /SfsSes=(\w+)/gi.exec(location.href);

$http.SfsSes = sessionStorage && sessionStorage.getItem("SfsSes");
if (tokens && tokens.length > 1) {
  $http.SfsSes = tokens[1];
  if (sessionStorage) {
    sessionStorage.setItem("SfsSes", $http.SfsSes);
    location.replace(location.href.replace(/&?SfsSes=(\w+)/gi, ''));
  }
}

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  if (config.loading === undefined || config.loading) {
    config.loading = "loading";
  }
  return config;
}, function (error) {
  if (error.config.loading) {}
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  if (response.config.loading) {}
  return response;
}, function (error) {
  if (error.config.loading) {}
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});
$http.ajax = function (url, data, method, options) {
  if (options === undefined) options = {};
  options.url = url;
  options.data = data;
  options.method = method;
  options.withCredentials = true;
  if ($http.SfsSes != undefined) {
    options.headers = options.headers || {};
    options.headers.SfsSes = $http.SfsSes;
  }

  return __WEBPACK_IMPORTED_MODULE_3_axios___default()(options).then(function (response) {
    if (!response.data.isSucc && options.failTips == undefined || options.failTips) {
      $utils.fail(response.data.message, 'fail');
      $utils.ErrorMessage.push(response.data.message);
      if ($utils.ErrorMessage.length > 5) {
        $utils.ErrorMessage = $utils.ErrorMessage.slice($utils.ErrorMessage.length - 5, $utils.ErrorMessage.length);
      }
      if (response.data.statusCode == 511) {
        location.href = '/login';
        return;
      }
    }
    return response;
  }).catch(function (error) {
    if (options.failTips == undefined || options.failTips) {
      $utils.fail(error.message, 'fail');
    } else {
      console.log(error);
    }
  });
};
$http.get = function (url, options) {
  if (options === undefined) options = {};
  return $http.ajax(url, options.data !== undefined ? {
    data: options.data
  } : "", "get", options);
};
$http.post = function (url, data, options) {
  if (options === undefined) options = {};

  for (var d in data) {
    if (data[d] instanceof Date) {
      data[d] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(data[d]).format("YYYY-MM-DD HH:mm:ss");
    }
  }
  return $http.ajax(url, $.param({
    data: (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) == "object" ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data) : data
  }), "post", options);
};
/* harmony default export */ __webpack_exports__["a"] = ($http);

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__systemApis__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policyApis__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__policyApis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__policyApis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orderApis__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__billApis__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseApis__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tourApis__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flightApis__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageApi__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tourPolicyApi__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hotelPolicyApi__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__trainPolicyApi__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flightPolicyApi__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__btripApi__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__trainApis__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hotelApi__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__workApis__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__insurancePolicyApis__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chargepolicyapi__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sideapi__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__tradeApis__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__logsApis__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__storageApis__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__adapterApis__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__huilianyiapi__ = __webpack_require__(260);
























/* harmony default export */ __webpack_exports__["a"] = ({
  system: __WEBPACK_IMPORTED_MODULE_0__systemApis__["a" /* default */],
  policy: __WEBPACK_IMPORTED_MODULE_1__policyApis___default.a,
  order: __WEBPACK_IMPORTED_MODULE_2__orderApis__["a" /* default */],
  bill: __WEBPACK_IMPORTED_MODULE_3__billApis__["a" /* default */],
  base: __WEBPACK_IMPORTED_MODULE_4__baseApis__["a" /* default */],
  tour: __WEBPACK_IMPORTED_MODULE_5__tourApis__["a" /* default */],
  flight: __WEBPACK_IMPORTED_MODULE_6__flightApis__["a" /* default */],
  message: __WEBPACK_IMPORTED_MODULE_7__messageApi__["a" /* default */],
  flightpolicy: __WEBPACK_IMPORTED_MODULE_11__flightPolicyApi__["a" /* default */],
  hotelpolicy: __WEBPACK_IMPORTED_MODULE_9__hotelPolicyApi__["a" /* default */],
  trainpolicy: __WEBPACK_IMPORTED_MODULE_10__trainPolicyApi__["a" /* default */],
  tourpolicy: __WEBPACK_IMPORTED_MODULE_8__tourPolicyApi__["a" /* default */],
  btrip: __WEBPACK_IMPORTED_MODULE_12__btripApi__["a" /* default */],
  train: __WEBPACK_IMPORTED_MODULE_13__trainApis__["a" /* default */],
  hotel: __WEBPACK_IMPORTED_MODULE_14__hotelApi__["a" /* default */],
  work: __WEBPACK_IMPORTED_MODULE_15__workApis__["a" /* default */],
  side: __WEBPACK_IMPORTED_MODULE_18__sideapi__["a" /* default */],
  insurancepolicy: __WEBPACK_IMPORTED_MODULE_16__insurancePolicyApis__["a" /* default */],
  chargepolicy: __WEBPACK_IMPORTED_MODULE_17__chargepolicyapi__["a" /* default */],
  trade: __WEBPACK_IMPORTED_MODULE_19__tradeApis__["a" /* default */],
  logs: __WEBPACK_IMPORTED_MODULE_20__logsApis__["a" /* default */],
  storage: __WEBPACK_IMPORTED_MODULE_21__storageApis__["a" /* default */],
  adapter: __WEBPACK_IMPORTED_MODULE_22__adapterApis__["a" /* default */],
  huilianyi: __WEBPACK_IMPORTED_MODULE_23__huilianyiapi__["a" /* default */],
  getService: function getService(serviceCode) {
    if (serviceCode != undefined) {
      return this[serviceCode.toLowerCase().replace("service", "")];
    }
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data = {
    "CompanyType": [{ "CategoryID": 1100, "CategoryTitle": "企事业单位", "CategoryCode": "EnterprisesUnit" }, { "CategoryID": 1101, "CategoryTitle": "政府机关", "CategoryCode": "GovernmentDepartment" }],
    "CapitalType": [{ "CategoryID": 1102, "CategoryTitle": "民营资产", "CategoryCode": "PeopleEnterprises" }, { "CategoryID": 1103, "CategoryTitle": "国有资产", "CategoryCode": "CountryCapital" }, { "CategoryID": 1104, "CategoryTitle": "中外合资", "CategoryCode": "ChinaOuterJoinCapital" }, { "CategoryID": 1105, "CategoryTitle": "外商独资", "CategoryCode": "ForeignCompany" }],
    "CompanySize": [{ "CategoryID": 1106, "CategoryTitle": "100人以下", "CategoryCode": "CompanySize100" }, { "CategoryID": 1107, "CategoryTitle": "100~499", "CategoryCode": "CompanySize499" }, { "CategoryID": 1108, "CategoryTitle": "500~999", "CategoryCode": "CompanySize999" }, { "CategoryID": 1109, "CategoryTitle": "1000~4999", "CategoryCode": "CompanySize4999" }, { "CategoryID": 1110, "CategoryTitle": "5000以上", "CategoryCode": "CompanySize5kUp" }],
    "ApplyArea": [{ "CategoryID": 1126, "CategoryTitle": "国内", "CategoryCode": "Internal" }, { "CategoryID": 1127, "CategoryTitle": "国际", "CategoryCode": "Overseas" }],
    "CardType": [{ "CategoryID": 1138, "CategoryTitle": "身份证", "CategoryCode": "IDCard" }, { "CategoryID": 1139, "CategoryTitle": "护照", "CategoryCode": "PassportCard" }, { "CategoryID": 1140, "CategoryTitle": "学生证", "CategoryCode": "StudentCard" }, { "CategoryID": 1141, "CategoryTitle": "军官证", "CategoryCode": "OfficerCard" }, { "CategoryID": 1296, "CategoryTitle": "港澳台居民居住证", "CategoryCode": "Residencepermit" }, { "CategoryID": 1297, "CategoryTitle": "外国人永久居留身份证", "CategoryCode": "ForeignResidentIDCard" }, { "CategoryID": 1298, "CategoryTitle": "港澳通行证", "CategoryCode": "HKMpermit" }, { "CategoryID": 1299, "CategoryTitle": "台湾通行证", "CategoryCode": "TaiWpermit" }, { "CategoryID": 1142, "CategoryTitle": "其它", "CategoryCode": "OtherCard" }],
    "UserStatus": [{ "CategoryID": 1143, "CategoryTitle": "启用", "CategoryCode": "Enable" }, { "CategoryID": 1144, "CategoryTitle": "禁用", "CategoryCode": "UnEnable" }],
    "Sex": [{ "CategoryID": 1145, "CategoryTitle": "男", "CategoryCode": "Male" }, { "CategoryID": 1146, "CategoryTitle": "女", "CategoryCode": "Female" }],
    "YesOrNo": [{ "CategoryID": 1150, "CategoryTitle": "是", "CategoryCode": "Yes" }, { "CategoryID": 1151, "CategoryTitle": "否", "CategoryCode": "No" }],
    "ChinaVoyageType": [{ "CategoryID": 1161, "CategoryTitle": "单程", "CategoryCode": "SingleVoyage" }, { "CategoryID": 1162, "CategoryTitle": "往返", "CategoryCode": "RoundVoyage" }, { "CategoryID": 1163, "CategoryTitle": "回程", "CategoryCode": "ReturnVoyage" }],
    "RoleType": [{ "CategoryID": 1311, "CategoryTitle": "用户", "CategoryCode": "User" }, { "CategoryID": 1312, "CategoryTitle": "职位", "CategoryCode": "Jobs" }, { "CategoryID": 1313, "CategoryTitle": "群组", "CategoryCode": "Group" }, { "CategoryID": 1314, "CategoryTitle": "部门", "CategoryCode": "Department" }, { "CategoryID": 1315, "CategoryTitle": "公司", "CategoryCode": "Company" }, { "CategoryID": 1316, "CategoryTitle": "服务", "CategoryCode": "Service" }, { "CategoryID": 1317, "CategoryTitle": "客户", "CategoryCode": "Customer" }, { "CategoryID": 1318, "CategoryTitle": "权限", "CategoryCode": "Action" }, { "CategoryID": 1319, "CategoryTitle": "成本中心", "CategoryCode": "CostCenter" }],
    "HotelPayType": [{ "CategoryID": 1195, "CategoryTitle": "预付", "CategoryCode": "HotelPrepay" }, { "CategoryID": 1196, "CategoryTitle": "现付", "CategoryCode": "HotelCashPay" }],
    "FlightType": [{ "CategoryID": 1193, "CategoryTitle": "普通航班", "CategoryCode": "CommonFlight" }, { "CategoryID": 1194, "CategoryTitle": "共享航班", "CategoryCode": "ShareFlight" }],
    "ConsumerType": [{ "CategoryID": 1701, "CategoryTitle": "婴儿", "CategoryCode": "Infant" }, { "CategoryID": 1703, "CategoryTitle": "儿童", "CategoryCode": "Enfant" }, { "CategoryID": 1705, "CategoryTitle": "成人", "CategoryCode": "Young" }, { "CategoryID": 1707, "CategoryTitle": "中年", "CategoryCode": "Wrinkly" }, { "CategoryID": 1709, "CategoryTitle": "老年", "CategoryCode": "Elderly" }],
    "BillCycle": [{ "CategoryID": 1260, "CategoryTitle": "月", "CategoryCode": "MonthCycle" }, { "CategoryID": 1261, "CategoryTitle": "周", "CategoryCode": "WeekCycle" }, { "CategoryID": 1262, "CategoryTitle": "日", "CategoryCode": "DayCycle" }],
    "ServiceMode": [{ "CategoryID": 1300, "CategoryTitle": "线上服务", "CategoryCode": "OnlineServiceMode" }, { "CategoryID": 1301, "CategoryTitle": "线下服务", "CategoryCode": "LineServiceMode" }],
    "CalcPriceMode": [{ "CategoryID": 1302, "CategoryTitle": "百分比", "CategoryCode": "PercentageMode" }, { "CategoryID": 1303, "CategoryTitle": "固定金额", "CategoryCode": "FixedPrice" }],
    "CalcBenchmark": [{ "CategoryID": 1304, "CategoryTitle": "票面价", "CategoryCode": "ExpensePrice" }, { "CategoryID": 1305, "CategoryTitle": "票面价+税费", "CategoryCode": "PriceFareAndTax" }],
    "RuntimeEnvironment": [{ "CategoryID": 1320, "CategoryTitle": "服务端", "CategoryCode": "Server" }, { "CategoryID": 1321, "CategoryTitle": "客户端", "CategoryCode": "Client" }],
    "WorkStatus": [{ "CategoryID": 1325, "CategoryTitle": "正常", "CategoryCode": "Normal" }, { "CategoryID": 1326, "CategoryTitle": "变更", "CategoryCode": "Change" }],
    "DataRange": [{ "CategoryID": 1332, "CategoryTitle": "不限制", "CategoryCode": "NoLimit" }, { "CategoryID": 1330, "CategoryTitle": "仅自己", "CategoryCode": "SelfOnly" }, { "CategoryID": 1331, "CategoryTitle": "自己及下级", "CategoryCode": "SelfLower" }, { "CategoryID": 1513, "CategoryTitle": "本部门", "CategoryCode": "Department" }, { "CategoryID": 1514, "CategoryTitle": "本部门及下级", "CategoryCode": "DepartmentLower" }],
    "AuthorizeState": [{ "CategoryID": 1335, "CategoryTitle": "未授权", "CategoryCode": "UnAuthorized" }, { "CategoryID": 1336, "CategoryTitle": "已授权", "CategoryCode": "Authorized" }],
    "RoleCategory": [{ "CategoryID": 1350, "CategoryTitle": "系统角色", "CategoryCode": "SystemRole" }, { "CategoryID": 1351, "CategoryTitle": "用户角色", "CategoryCode": "UserRole" }],
    "EventType": [{ "CategoryID": 1356, "CategoryTitle": "继续之前", "CategoryCode": "ContinueBefore" }, { "CategoryID": 1357, "CategoryTitle": "继续之后", "CategoryCode": "ContinueAfter" }, { "CategoryID": 1358, "CategoryTitle": "退回之前", "CategoryCode": "ReturnBefore" }, { "CategoryID": 1359, "CategoryTitle": "退回之后", "CategoryCode": "ReturnAfter" }, { "CategoryID": 1360, "CategoryTitle": "变更之前", "CategoryCode": "ChangeBefore" }, { "CategoryID": 1361, "CategoryTitle": "变更之后", "CategoryCode": "ChangeAfter" }],
    "InvoiceStatus": [{ "CategoryID": 1362, "CategoryTitle": "需要发票", "CategoryCode": "NeedInvoice" }, { "CategoryID": 1363, "CategoryTitle": "不要发票", "CategoryCode": "NoInvoice" }],
    "CreateMode": [{ "CategoryID": 1364, "CategoryTitle": "网站", "CategoryCode": "WEB" }],
    "UnitPrice": [{ "CategoryID": 1369, "CategoryTitle": "元", "CategoryCode": "RMB" }, { "CategoryID": 1370, "CategoryTitle": "美元", "CategoryCode": "Dollar" }],
    "TradeMode": [{ "CategoryID": 1371, "CategoryTitle": "支付宝", "CategoryCode": "Alipay" }, { "CategoryID": 1372, "CategoryTitle": "微信", "CategoryCode": "WeChat" }, { "CategoryID": 1373, "CategoryTitle": "现金", "CategoryCode": "Cash" }, { "CategoryID": 1374, "CategoryTitle": "月结", "CategoryCode": "Monthly" }, { "CategoryID": 1483, "CategoryTitle": "转账", "CategoryCode": "Transfer" }],
    "ProductType": [{ "CategoryID": 1375, "CategoryTitle": "旅游", "CategoryCode": "Tour" }, { "CategoryID": 1376, "CategoryTitle": "酒店", "CategoryCode": "Hotel" }, { "CategoryID": 1377, "CategoryTitle": "机票", "CategoryCode": "Flight" }, { "CategoryID": 1484, "CategoryTitle": "火车票", "CategoryCode": "Train" }],
    "FileType": [{ "CategoryID": 1378, "CategoryTitle": "出团通知书", "CategoryCode": "AdviceNote" }, { "CategoryID": 1379, "CategoryTitle": "客人附件", "CategoryCode": "GuestEnclosure" }, { "CategoryID": 1381, "CategoryTitle": "其他", "CategoryCode": "other" }, { "CategoryID": 1382, "CategoryTitle": "电子合同", "CategoryCode": "Electronic" }],
    "MessageType": [{ "CategoryID": 1383, "CategoryTitle": "给客人留言", "CategoryCode": "ClientMessage" }, { "CategoryID": 1384, "CategoryTitle": "给供应留言", "CategoryCode": "SupplyMessage" }, { "CategoryID": 1385, "CategoryTitle": "给同事留言", "CategoryCode": "WorkmateMessage" }],
    "TravelStatus": [{ "CategoryID": 1390, "CategoryTitle": "已出游", "CategoryCode": "Traveled" }, { "CategoryID": 1391, "CategoryTitle": "未出游", "CategoryCode": "NotTravel" }],
    "OrderType": [{ "CategoryID": 1397, "CategoryTitle": "销售", "CategoryCode": "Sell" }, { "CategoryID": 1398, "CategoryTitle": "退款", "CategoryCode": "DrawBack" }],
    "BusinessType": [{ "CategoryID": 1797, "CategoryTitle": "销售", "CategoryCode": "Sales" }, { "CategoryID": 1789, "CategoryTitle": "变更", "CategoryCode": "Change" }, { "CategoryID": 1799, "CategoryTitle": "退废", "CategoryCode": "Amend" }, { "CategoryID": 1791, "CategoryTitle": "账务", "CategoryCode": "Bill" }, { "CategoryID": 1793, "CategoryTitle": "公司", "CategoryCode": "Company" }, { "CategoryID": 1795, "CategoryTitle": "产品", "CategoryCode": "Product" }, { "CategoryID": 1801, "CategoryTitle": "个人", "CategoryCode": "People" }],
    "SecurityType": [{ "CategoryID": 1399, "CategoryTitle": "登录密码", "CategoryCode": "PasswordVerify" }, { "CategoryID": 1400, "CategoryTitle": "邮箱验证", "CategoryCode": "EmailVerify" }, { "CategoryID": 1401, "CategoryTitle": "手机验证", "CategoryCode": "PhoneVerify" }, { "CategoryID": 1402, "CategoryTitle": "实名验证", "CategoryCode": "NameVerify" }, { "CategoryID": 1403, "CategoryTitle": "安全问题", "CategoryCode": "SafetyProblem" }],
    "Source": [{ "CategoryID": 1404, "CategoryTitle": "网站", "CategoryCode": "Pc" }, { "CategoryID": 1405, "CategoryTitle": "手机", "CategoryCode": "App" }, { "CategoryID": 1803, "CategoryTitle": "客服", "CategoryCode": "Customer" }, { "CategoryID": 1984, "CategoryTitle": "需求", "CategoryCode": "Demand" }],
    "ServiceType": [{ "CategoryID": 0, "CategoryTitle": "通用服务", "CategoryCode": "CommonService" }, { "CategoryID": 1409, "CategoryTitle": "机票服务", "CategoryCode": "FlightService" }, { "CategoryID": 1407, "CategoryTitle": "酒店服务", "CategoryCode": "HotelService" }, { "CategoryID": 1470, "CategoryTitle": "火车服务", "CategoryCode": "TrainService" }, { "CategoryID": 1408, "CategoryTitle": "旅游服务", "CategoryCode": "TourService" }, { "CategoryID": 1406, "CategoryTitle": "商旅服务", "CategoryCode": "BtripService" }, { "CategoryID": 1466, "CategoryTitle": "保险服务", "CategoryCode": "InsuranceService" }, { "CategoryID": 1467, "CategoryTitle": "快递服务", "CategoryCode": "ExpressService" }, { "CategoryID": 1468, "CategoryTitle": "发票服务", "CategoryCode": "InvoiceService" }, { "CategoryID": 1469, "CategoryTitle": "签证服务", "CategoryCode": "VisaService" }, { "CategoryID": 1554, "CategoryTitle": "餐饮服务", "CategoryCode": "CaterService" }, { "CategoryID": 1555, "CategoryTitle": "交通服务", "CategoryCode": "TrafficService" }, { "CategoryID": 1556, "CategoryTitle": "门票服务", "CategoryCode": "TicketService" }, { "CategoryID": 1557, "CategoryTitle": "基础服务", "CategoryCode": "BaseService" }, { "CategoryID": 1636, "CategoryTitle": "系统服务", "CategoryCode": "SystemService" }, { "CategoryID": 1637, "CategoryTitle": "工作服务", "CategoryCode": "WorkService" }, { "CategoryID": 1638, "CategoryTitle": "订单服务", "CategoryCode": "OrderService" }, { "CategoryID": 1640, "CategoryTitle": "账单服务", "CategoryCode": "BillService" }, { "CategoryID": 1643, "CategoryTitle": "个人服务", "CategoryCode": "UserService" }, { "CategoryID": 1645, "CategoryTitle": "企业服务", "CategoryCode": "CompanyService" }, { "CategoryID": 1410, "CategoryTitle": "增值服务", "CategoryCode": "ChargeService" }],
    "ProblemType": [{ "CategoryID": 1411, "CategoryTitle": "高中班主任是谁", "CategoryCode": "HightDirector" }, { "CategoryID": 1412, "CategoryTitle": "第一次通关的游戏", "CategoryCode": "Firstgame" }],
    "ContactType": [{ "CategoryID": 1413, "CategoryTitle": "手机", "CategoryCode": "PhoneContact" }, { "CategoryID": 1414, "CategoryTitle": "电话", "CategoryCode": "TelephoneContact" }, { "CategoryID": 1415, "CategoryTitle": "邮箱", "CategoryCode": "EmailContact" }, { "CategoryID": 1416, "CategoryTitle": "QQ", "CategoryCode": "QQ" }],
    "SetsType": [{ "CategoryID": 1417, "CategoryTitle": "网上预订须知", "CategoryCode": "OnlineKnow" }, { "CategoryID": 1418, "CategoryTitle": "国内旅游预订须知", "CategoryCode": "TourKnow" }],
    "TeamStatus": [{ "CategoryID": 1419, "CategoryTitle": "启用", "CategoryCode": "Enable" }, { "CategoryID": 1420, "CategoryTitle": "禁用", "CategoryCode": "UnEnable" }],
    "PriceStatus": [{ "CategoryID": 1421, "CategoryTitle": "价格启用", "CategoryCode": "PriceEnable" }, { "CategoryID": 1422, "CategoryTitle": "价格禁用", "CategoryCode": "PriceUnEnable" }, { "CategoryID": 1423, "CategoryTitle": "价格待定", "CategoryCode": "Indeterminate" }],
    "PolicyType": [{ "CategoryID": 1426, "CategoryTitle": "私有政策", "CategoryCode": "PrivatePolicy" }, { "CategoryID": 1427, "CategoryTitle": "公有政策", "CategoryCode": "PublicPolicy" }],
    "TradeType": [{ "CategoryID": 1428, "CategoryTitle": "收款", "CategoryCode": "Receive" }, { "CategoryID": 1429, "CategoryTitle": "付款", "CategoryCode": "Payment" }],
    "TradeStatus": [{ "CategoryID": 1610, "CategoryTitle": "待提交", "CategoryCode": "WaitSubmit" }, { "CategoryID": 1612, "CategoryTitle": "待付款", "CategoryCode": "WaitPayment" }, { "CategoryID": 1614, "CategoryTitle": "未确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 1616, "CategoryTitle": "已确认", "CategoryCode": "Finished" }, { "CategoryID": 1618, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }, { "CategoryID": 1620, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }],
    "AuditStatus": [{ "CategoryID": 1434, "CategoryTitle": "未审批", "CategoryCode": "Unaudit" }, { "CategoryID": 1435, "CategoryTitle": "已审批", "CategoryCode": "Audited" }, { "CategoryID": 1436, "CategoryTitle": "审批拒绝", "CategoryCode": "AuditRefuse" }],
    "ApplyStatus": [{ "CategoryID": 1432, "CategoryTitle": "未提交", "CategoryCode": "Unsubmit" }, { "CategoryID": 1433, "CategoryTitle": "已提交", "CategoryCode": "Submited" }],
    "RefundStatus": [{ "CategoryID": 1438, "CategoryTitle": "未处理", "CategoryCode": "Untreated" }, { "CategoryID": 1439, "CategoryTitle": "退团失败", "CategoryCode": "RefundeBad" }, { "CategoryID": 1440, "CategoryTitle": "退团处理中", "CategoryCode": "RefundeIng" }, { "CategoryID": 1441, "CategoryTitle": "退团成功", "CategoryCode": "Refunded" }],
    "ZoneType": [{ "CategoryID": 1442, "CategoryTitle": "国家", "CategoryCode": "Country" }, { "CategoryID": 1443, "CategoryTitle": "景区", "CategoryCode": "Scenic" }, { "CategoryID": 1444, "CategoryTitle": "城市", "CategoryCode": "City" }, { "CategoryID": 1445, "CategoryTitle": "省份", "CategoryCode": "Province" }, { "CategoryID": 1446, "CategoryTitle": "区域", "CategoryCode": "Area" }, { "CategoryID": 1447, "CategoryTitle": "机场", "CategoryCode": "Airport" }, { "CategoryID": 1448, "CategoryTitle": "洲际", "CategoryCode": "Continent" }, { "CategoryID": 1449, "CategoryTitle": "区县", "CategoryCode": "District" }, { "CategoryID": 1807, "CategoryTitle": "车站", "CategoryCode": "Station" }, { "CategoryID": 1809, "CategoryTitle": "商圈", "CategoryCode": "Business" }],
    "TicketDelivery": [{ "CategoryID": 1450, "CategoryTitle": "自取", "CategoryCode": "Invite" }, { "CategoryID": 1451, "CategoryTitle": "邮寄", "CategoryCode": "Mail" }],
    "TicketType": [{ "CategoryID": 1164, "CategoryTitle": "BSP", "CategoryCode": "BSP" }, { "CategoryID": 1165, "CategoryTitle": "B2B", "CategoryCode": "B2B" }, { "CategoryID": 1166, "CategoryTitle": "境外电子", "CategoryCode": "OverseasElectronic" }],
    "BackAirportType": [{ "CategoryID": 1180, "CategoryTitle": "同一洲际范围内", "CategoryCode": "WithinIntercontinental" }, { "CategoryID": 1181, "CategoryTitle": "政策始发机场范围", "CategoryCode": "PolicyDepartAirport" }, { "CategoryID": 1184, "CategoryTitle": "必须返回行程出发机场", "CategoryCode": "MustBackAirport" }, { "CategoryID": 1185, "CategoryTitle": "指定返回国家或机场范围", "CategoryCode": "AppointBackAirport" }],
    "ApplicableObject": [{ "CategoryID": 1168, "CategoryTitle": "团队", "CategoryCode": "Team" }, { "CategoryID": 1169, "CategoryTitle": "散客", "CategoryCode": "Fit" }, { "CategoryID": 1170, "CategoryTitle": "不限", "CategoryCode": "Unlimited" }],
    "ApplyPrice": [{ "CategoryID": 1171, "CategoryTitle": "高开", "CategoryCode": "HighOpen" }, { "CategoryID": 1172, "CategoryTitle": "低开", "CategoryCode": "DownOpen" }],
    "ApplyWeek": [{ "CategoryID": 1173, "CategoryTitle": "一", "CategoryCode": "Monday" }, { "CategoryID": 1174, "CategoryTitle": "二", "CategoryCode": "Tuesday" }, { "CategoryID": 1175, "CategoryTitle": "三", "CategoryCode": "Wednesday" }, { "CategoryID": 1176, "CategoryTitle": "四", "CategoryCode": "Thursday" }, { "CategoryID": 1177, "CategoryTitle": "五", "CategoryCode": "Friday" }, { "CategoryID": 1178, "CategoryTitle": "六", "CategoryCode": "Saturday" }, { "CategoryID": 1179, "CategoryTitle": "日", "CategoryCode": "Sunday" }],
    "LimitPassageType": [{ "CategoryID": 1200, "CategoryTitle": "留学生", "CategoryCode": "OverseasStudent" }, { "CategoryID": 1201, "CategoryTitle": "移民", "CategoryCode": "Immigrant" }, { "CategoryID": 1202, "CategoryTitle": "劳工", "CategoryCode": "Worker" }, { "CategoryID": 1203, "CategoryTitle": "海员", "CategoryCode": "Seaman" }, { "CategoryID": 1204, "CategoryTitle": "青年", "CategoryCode": "Youth" }, { "CategoryID": 1205, "CategoryTitle": "港澳台", "CategoryCode": "HkMacaoTw" }, { "CategoryID": 1206, "CategoryTitle": "外籍", "CategoryCode": "ForeignNationality" }, { "CategoryID": 1207, "CategoryTitle": "非汉字姓名", "CategoryCode": "NotChineseName" }, { "CategoryID": 1208, "CategoryTitle": "Add-On", "CategoryCode": "AddOn" }, { "CategoryID": 1209, "CategoryTitle": "老年", "CategoryCode": "OldGge" }, { "CategoryID": 1210, "CategoryTitle": "境外中转", "CategoryCode": "OverseasTransfer" }, { "CategoryID": 1211, "CategoryTitle": "缺口程", "CategoryCode": "NotchRange" }, { "CategoryID": 1212, "CategoryTitle": "OPEN", "CategoryCode": "OPEN" }, { "CategoryID": 1213, "CategoryTitle": "SPA", "CategoryCode": "SPA" }, { "CategoryID": 1214, "CategoryTitle": "Q值", "CategoryCode": "QValue" }, { "CategoryID": 1215, "CategoryTitle": "共享航班", "CategoryCode": "SharedFlight" }, { "CategoryID": 1216, "CategoryTitle": "三方协议", "CategoryCode": "ThreeAgreement" }, { "CategoryID": 1217, "CategoryTitle": "套票", "CategoryCode": "Package" }, { "CategoryID": 1218, "CategoryTitle": "整团", "CategoryCode": "WholeGroup" }, { "CategoryID": 1219, "CategoryTitle": "小团", "CategoryCode": "SmallGroup" }],
    "FreightBasicsRule": [{ "CategoryID": 1182, "CategoryTitle": "无奖励", "CategoryCode": "NoReward" }, { "CategoryID": 1183, "CategoryTitle": "无代理费", "CategoryCode": "AgencyFreeFee" }],
    "ChildrewardRules": [{ "CategoryID": 1220, "CategoryTitle": "奖励与成人一样", "CategoryCode": "RewardsAdults" }, { "CategoryID": 1221, "CategoryTitle": "可无开奖励", "CategoryCode": "NoOpenBonus" }, { "CategoryID": 1463, "CategoryTitle": "可开无代理费", "CategoryCode": "openAgencyFee" }, { "CategoryID": 1464, "CategoryTitle": "不可开", "CategoryCode": "NoWay" }],
    "BabywardRules": [{ "CategoryID": 1222, "CategoryTitle": "可开无奖励", "CategoryCode": "WithoutReward" }, { "CategoryID": 1223, "CategoryTitle": "不可开", "CategoryCode": "NotOpen" }],
    "CodingRule": [{ "CategoryID": 1224, "CategoryTitle": "无需换编码", "CategoryCode": "NoCodingRequired" }, { "CategoryID": 1225, "CategoryTitle": "换编码出票", "CategoryCode": "CodeOut" }, { "CategoryID": 1226, "CategoryTitle": "大编出票（无需换编）", "CategoryCode": "BigTicket" }, { "CategoryID": 1227, "CategoryTitle": "大编出票（需换编）", "CategoryCode": "BigNoTicket" }, { "CategoryID": 1228, "CategoryTitle": "无位不换出票（外放有位时换编）", "CategoryCode": "NoChange" }],
    "InterVoyageType": [{ "CategoryID": 1230, "CategoryTitle": "单程", "CategoryCode": "SingleVoyage" }, { "CategoryID": 1231, "CategoryTitle": "往返", "CategoryCode": "RoundVoyage" }, { "CategoryID": 1232, "CategoryTitle": "单程/往返", "CategoryCode": "SingleRound" }],
    "PointsType": [{ "CategoryID": 1306, "CategoryTitle": "直接修改", "CategoryCode": "DirectUpdate" }, { "CategoryID": 1307, "CategoryTitle": "加点", "CategoryCode": "AddLittle" }, { "CategoryID": 1308, "CategoryTitle": "减点", "CategoryCode": "ReduceLittle" }],
    "AirlineType": [{ "CategoryID": 1452, "CategoryTitle": "国内始发", "CategoryCode": "insideOutside" }, { "CategoryID": 1453, "CategoryTitle": "直飞SOTO程", "CategoryCode": "outsideInside" }, { "CategoryID": 1454, "CategoryTitle": "国内始发Add-On", "CategoryCode": "insideInsideOutside" }, { "CategoryID": 1455, "CategoryTitle": "国外始发Add-On", "CategoryCode": "outsideInsideInside" }, { "CategoryID": 1456, "CategoryTitle": "境外到境外", "CategoryCode": "outsideOutside" }, { "CategoryID": 1457, "CategoryTitle": "国内始发中转", "CategoryCode": "insideOutsideOutside" }, { "CategoryID": 1458, "CategoryTitle": "国外始发中转", "CategoryCode": "outsideOutsideInside" }, { "CategoryID": 1459, "CategoryTitle": "境外境外境外", "CategoryCode": "outsideOutsideOutside" }, { "CategoryID": 1460, "CategoryTitle": "境外境内境外", "CategoryCode": "outsideInsideOutside" }, { "CategoryID": 1461, "CategoryTitle": "全球到全球", "CategoryCode": "globalGlobal" }, { "CategoryID": 1462, "CategoryTitle": "全球中转全球", "CategoryCode": "globalGlobalGlobal" }],
    "InformationsType": [{ "CategoryID": 1471, "CategoryTitle": "预订须知", "CategoryCode": "TravelNotes" }, { "CategoryID": 1472, "CategoryTitle": "费用须知", "CategoryCode": "ExpenseKnowledge" }],
    "NotificationType": [{ "CategoryID": 1473, "CategoryTitle": "短信", "CategoryCode": "ShortMessage" }, { "CategoryID": 1474, "CategoryTitle": "邮件", "CategoryCode": "Mail" }, { "CategoryID": 1475, "CategoryTitle": "微信", "CategoryCode": "Wechat" }],
    "ExamineType": [{ "CategoryID": 1476, "CategoryTitle": "审批订单消息内容", "CategoryCode": "EexamineOrderSms" }, { "CategoryID": 1477, "CategoryTitle": "审批通过消息内容", "CategoryCode": "EexamineApprovalSms" }, { "CategoryID": 1478, "CategoryTitle": "审批拒绝消息内容", "CategoryCode": "EexamineRefuseSms" }, { "CategoryID": 1479, "CategoryTitle": "订单处理完成消息内容", "CategoryCode": "EexamineAccomplishSms" }, { "CategoryID": 1480, "CategoryTitle": "退款完成", "CategoryCode": "Refunds" }],
    "TrainSeatType": [{ "CategoryID": 1485, "CategoryTitle": "商务座", "CategoryCode": "BusinessSeat" }, { "CategoryID": 1486, "CategoryTitle": "特等座", "CategoryCode": "SpecialSeat" }, { "CategoryID": 1487, "CategoryTitle": "一等座", "CategoryCode": "Level1Seat" }, { "CategoryID": 1488, "CategoryTitle": "二等座", "CategoryCode": "Level2Seat" }, { "CategoryID": 1489, "CategoryTitle": "高级软卧", "CategoryCode": "HighGradeSleeper" }, { "CategoryID": 1490, "CategoryTitle": "软卧", "CategoryCode": "CommonSleeper" }, { "CategoryID": 1491, "CategoryTitle": "硬卧", "CategoryCode": "HardSleeper" }, { "CategoryID": 1492, "CategoryTitle": "软座", "CategoryCode": "SoftSeat" }, { "CategoryID": 1493, "CategoryTitle": "硬座", "CategoryCode": "HardSeat" }, { "CategoryID": 1494, "CategoryTitle": "无座", "CategoryCode": "NotHaveSeat" }, { "CategoryID": 1495, "CategoryTitle": "动卧", "CategoryCode": "MotionSupine" }],
    "Cabin": [{ "CategoryID": 1496, "CategoryTitle": "经济舱", "CategoryCode": "Economy" }, { "CategoryID": 1498, "CategoryTitle": "商务舱", "CategoryCode": "Buissenes" }, { "CategoryID": 1500, "CategoryTitle": "头等舱", "CategoryCode": "First" }, { "CategoryID": 1859, "CategoryTitle": "经济舱(9折)", "CategoryCode": "Economy9" }, { "CategoryID": 1857, "CategoryTitle": "经济舱(8折)", "CategoryCode": "Economy8" }, { "CategoryID": 1855, "CategoryTitle": "经济舱(7折)", "CategoryCode": "Economy7" }, { "CategoryID": 1853, "CategoryTitle": "经济舱(6折)", "CategoryCode": "Economy6" }, { "CategoryID": 1851, "CategoryTitle": "经济舱(5折)", "CategoryCode": "Economy5" }],
    "LowestRule": [{ "CategoryID": 0, "CategoryTitle": "无限制", "CategoryCode": "NoLimit" }, { "CategoryID": 1501, "CategoryTitle": "相对最低价", "CategoryCode": "ControLowestPrice" }, { "CategoryID": 1502, "CategoryTitle": "全天最低价", "CategoryCode": "DayLowestPrice" }, { "CategoryID": 1503, "CategoryTitle": "时段最低价", "CategoryCode": "TimeAreaLowestPrice" }, { "CategoryID": 1504, "CategoryTitle": "航班最低价", "CategoryCode": "FlightLowestPrice" }],
    "TrainType": [{ "CategoryID": 1505, "CategoryTitle": "高铁", "CategoryCode": "HighSpeedRail" }, { "CategoryID": 1506, "CategoryTitle": "卧铺", "CategoryCode": "SleepingBerth" }, { "CategoryID": 1507, "CategoryTitle": "普车及其它", "CategoryCode": "Other" }],
    "ApplicableCase": [{ "CategoryID": 1508, "CategoryTitle": "全部", "CategoryCode": "Whole" }, { "CategoryID": 1509, "CategoryTitle": "职位", "CategoryCode": "Position" }, { "CategoryID": 1510, "CategoryTitle": "部门", "CategoryCode": "Department" }],
    "CollectFeesType": [{ "CategoryID": 1511, "CategoryTitle": "按固定收费", "CategoryCode": "FlatFeeCharges" }, { "CategoryID": 1512, "CategoryTitle": "按百分比收费", "CategoryCode": "PercentageCostFee" }],
    "TravelReasonType": [{ "CategoryID": 1515, "CategoryTitle": "差旅目的", "CategoryCode": "TravelPurpose" }, { "CategoryID": 1516, "CategoryTitle": "违背原因", "CategoryCode": "PolicyCause" }, { "CategoryID": 1528, "CategoryTitle": "预订须知", "CategoryCode": "BookingInfo" }],
    "FlightRefundReason": [{ "CategoryID": 1517, "CategoryTitle": "我要改变行程,不想飞了", "CategoryCode": "FlightChange" }, { "CategoryID": 1518, "CategoryTitle": "记错行程、日期、时间、姓名", "CategoryCode": "FlightMistaken" }, { "CategoryID": 1519, "CategoryTitle": "航班延误或取消", "CategoryCode": "FlightDelay" }],
    "BookingType": [{ "CategoryID": 1529, "CategoryTitle": "因公", "CategoryCode": "OnBusiness" }, { "CategoryID": 1530, "CategoryTitle": "因私", "CategoryCode": "OnPersonal" }],
    "ApprovalRecordType": [{ "CategoryID": 1531, "CategoryTitle": "订单支付审批", "CategoryCode": "PayApproval" }, { "CategoryID": 1532, "CategoryTitle": "订单改签审批", "CategoryCode": "ChangeApproval" }, { "CategoryID": 1533, "CategoryTitle": "订单退票审批", "CategoryCode": "ReturnTicketApproval" }],
    "ReservationMode": [{ "CategoryID": 1536, "CategoryTitle": "线上预订", "CategoryCode": "OnLineReservation" }, { "CategoryID": 1537, "CategoryTitle": "线下预订", "CategoryCode": "OffLineReservation" }],
    "ServiceTimeType": [{ "CategoryID": 1538, "CategoryTitle": "工作时间", "CategoryCode": "WorkingTime" }, { "CategoryID": 1539, "CategoryTitle": "非工作时间", "CategoryCode": "NonWorkingTime" }],

    "TripApprovalRule": [{ "CategoryID": 1541, "CategoryTitle": "线上预订需要审批", "CategoryCode": "OnlineBookingApproval" }, { "CategoryID": 1542, "CategoryTitle": "线下预订需要审批", "CategoryCode": "OfflineBookingApproval" }, { "CategoryID": 1545, "CategoryTitle": "违背规则需要审批", "CategoryCode": "ViolateRuleApproval" }, { "CategoryID": 1546, "CategoryTitle": "更改行程需要审批", "CategoryCode": "ChangeTripApproval" }, { "CategoryID": 1547, "CategoryTitle": "取消行程需要审批", "CategoryCode": "CancelTripApproval" }, { "CategoryID": 1543, "CategoryTitle": "必需选择成本中心", "CategoryCode": "CostCenterRequire" }, { "CategoryID": 1544, "CategoryTitle": "必需填写项目代码", "CategoryCode": "ProjectCodeRequire" }, { "CategoryID": 1540, "CategoryTitle": "必需填写违背原因", "CategoryCode": "ContraryReasonRequire" }, { "CategoryID": 1580, "CategoryTitle": "必需填写差旅目的", "CategoryCode": "IntentTripApproval" }, { "CategoryID": 1582, "CategoryTitle": "必需填写审批单号", "CategoryCode": "ApprovalNoRequire" }, { "CategoryID": 1584, "CategoryTitle": "允许填写审批单号", "CategoryCode": "ApprovalDisplayOnly" }],
    "FlightTimeStatus": [{ "CategoryID": 1548, "CategoryTitle": "起飞前", "CategoryCode": "Preflight" }, { "CategoryID": 1549, "CategoryTitle": "起飞后", "CategoryCode": "AfterTakeoff" }],
    "RuleType": [{ "CategoryID": 1550, "CategoryTitle": "改签", "CategoryCode": "RuleEndorse" }, { "CategoryID": 1551, "CategoryTitle": "退票", "CategoryCode": "RuleFund" }, { "CategoryID": 1553, "CategoryTitle": "预订", "CategoryCode": "Reserve" }],
    "ExpensesType": [{ "CategoryID": 1534, "CategoryTitle": "按人收费", "CategoryCode": "People" }, { "CategoryID": 1535, "CategoryTitle": "按产品收费", "CategoryCode": "legs" }],
    "DelayType": [{ "CategoryID": 1559, "CategoryTitle": "自愿", "CategoryCode": "Volunteer" }, { "CategoryID": 1561, "CategoryTitle": "航变", "CategoryCode": "FlightChang" }, { "CategoryID": 1563, "CategoryTitle": "重购", "CategoryCode": "BuyAgain" }, { "CategoryID": 1565, "CategoryTitle": "病退", "CategoryCode": "SickAmend" }, { "CategoryID": 1567, "CategoryTitle": "名字错误", "CategoryCode": "NameError" }, { "CategoryID": 1569, "CategoryTitle": "升舱换开", "CategoryCode": "CabinChange" }, { "CategoryID": 1571, "CategoryTitle": "废票", "CategoryCode": "TicketInvalid" }, { "CategoryID": 1573, "CategoryTitle": "其他", "CategoryCode": "Other" }],
    "CompanyCard": [{ "CategoryID": 1720, "CategoryTitle": "营业执照", "CategoryCode": "BusinessLicence" }, { "CategoryID": 1722, "CategoryTitle": "税务登记证", "CategoryCode": "TaxRegistration" }, { "CategoryID": 1730, "CategoryTitle": "其他", "CategoryCode": "Other" }],
    "ActiveStatus": [{ "CategoryID": 1750, "CategoryTitle": "待审批", "CategoryCode": "WaitSubmit" }, { "CategoryID": 1752, "CategoryTitle": "审批中", "CategoryCode": "WaitDispose" }, { "CategoryID": 1754, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }, { "CategoryID": 1756, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 1758, "CategoryTitle": "已拒绝", "CategoryCode": "Rejected" }],
    "PriceType": [{ "CategoryID": 1672, "CategoryTitle": "房费", "CategoryCode": "HotelFare" }, { "CategoryID": 1674, "CategoryTitle": "团费", "CategoryCode": "TeamFare" }, { "CategoryID": 1660, "CategoryTitle": "票面", "CategoryCode": "TicketFare" }, { "CategoryID": 1662, "CategoryTitle": "机建", "CategoryCode": "BuildFare" }, { "CategoryID": 1664, "CategoryTitle": "燃油", "CategoryCode": "FuelFare" }, { "CategoryID": 1666, "CategoryTitle": "税费", "CategoryCode": "TaxFare" }, { "CategoryID": 1692, "CategoryTitle": "直减", "CategoryCode": "DirectReduction" }, { "CategoryID": 1668, "CategoryTitle": "保险", "CategoryCode": "SafeFare" }, { "CategoryID": 1670, "CategoryTitle": "服务费", "CategoryCode": "ServiceFare" }, { "CategoryID": 1678, "CategoryTitle": "退票", "CategoryCode": "AmendFare" }, { "CategoryID": 1682, "CategoryTitle": "变更", "CategoryCode": "ChangeFare" }, { "CategoryID": 1684, "CategoryTitle": "原价", "CategoryCode": "OldPrice" }, { "CategoryID": 1690, "CategoryTitle": "其它", "CategoryCode": "OtherFare" }],
    "FlowMode": [{ "CategoryID": 1760, "CategoryTitle": "交易审批", "CategoryCode": "Bill" }],
    "AccountType": [{ "CategoryID": 1765, "CategoryTitle": "余额", "CategoryCode": "Balance" }, { "CategoryID": 1767, "CategoryTitle": "信用", "CategoryCode": "Credit" }, { "CategoryID": 1769, "CategoryTitle": "积分", "CategoryCode": "Integral" }],
    "CreditType": [{ "CategoryID": 1771, "CategoryTitle": "固定授信", "CategoryCode": "FixedCredit" }, { "CategoryID": 1773, "CategoryTitle": "临时授信", "CategoryCode": "InterimCredit" }],
    "BillStatus": [{ "CategoryID": 1777, "CategoryTitle": "待出帐", "CategoryCode": "WaitOutDay" }, { "CategoryID": 1779, "CategoryTitle": "待审核", "CategoryCode": "WaitAudited" }, { "CategoryID": 1781, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 1783, "CategoryTitle": "待收款", "CategoryCode": "WaitReceive" }, { "CategoryID": 1785, "CategoryTitle": "已关账", "CategoryCode": "Finished" }, { "CategoryID": 1787, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }],
    "PaymentType": [{ "CategoryID": 1195, "CategoryTitle": "预付", "CategoryCode": "Prepay" }, { "CategoryID": 1196, "CategoryTitle": "现付", "CategoryCode": "CashPay" }],
    "HotelRefundReason": [{ "CategoryID": 1805, "CategoryTitle": "行程变更", "CategoryCode": "HotelChange" }, { "CategoryID": 1837, "CategoryTitle": "行程取消", "CategoryCode": "HotelDelay" }],
    "InvoiceRole": [{ "CategoryID": 1813, "CategoryTitle": "公司", "CategoryCode": "Company" }, { "CategoryID": 1815, "CategoryTitle": "个人", "CategoryCode": "People" }],
    "InvoiceType": [{ "CategoryID": 1821, "CategoryTitle": "专用发票", "CategoryCode": "SpecialTicket" }, { "CategoryID": 1823, "CategoryTitle": "普通发票", "CategoryCode": "GeneralTicket" }],
    'TakeType': [{ "CategoryID": 1825, "CategoryTitle": "电子发票", "CategoryCode": "Electronic" }, { "CategoryID": 1827, "CategoryTitle": "纸质发票", "CategoryCode": "Paper" }],
    'NotifyType': [{ "CategoryID": 1865, "CategoryTitle": "短信通知", "CategoryCode": "MessageNotify" }, { "CategoryID": 1867, "CategoryTitle": "邮件通知", "CategoryCode": "MailNotify" }, { "CategoryID": 1869, "CategoryTitle": "微信通知", "CategoryCode": "WechatNotify" }, { "CategoryID": 1871, "CategoryTitle": "App通知", "CategoryCode": "AppNotify" }],
    'AuthType': [{ "CategoryID": 10220, "CategoryTitle": "邮箱账号", "CategoryCode": "EmailAuth" }, { "CategoryID": 10222, "CategoryTitle": "手机账号", "CategoryCode": "MobileAuth" }, { "CategoryID": 10224, "CategoryTitle": "账号密码", "CategoryCode": "AccountAuth" }, { "CategoryID": 10230, "CategoryTitle": "微信授权", "CategoryCode": "WeixinAuth" }, { "CategoryID": 10250, "CategoryTitle": "动态密码", "CategoryCode": "DynamicAuth" }],
    'NotifyContentType': [{ "CategoryID": 1940, "CategoryTitle": "文本", "CategoryCode": "Text" }, { "CategoryID": 1945, "CategoryTitle": "HTML", "CategoryCode": "Html" }, { "CategoryID": 1950, "CategoryTitle": "链接", "CategoryCode": "Link" }, { "CategoryID": 1955, "CategoryTitle": "插件", "CategoryCode": "Plugin" }],
    'NotifyScope': [{ "CategoryID": 1960, "CategoryTitle": "公司内部", "CategoryCode": "CompanyInternal" }, { "CategoryID": 1962, "CategoryTitle": "当前域名", "CategoryCode": "CurrentDomainName" }, { "CategoryID": 1964, "CategoryTitle": "所有域名", "CategoryCode": "AllDomainName" }]
};
data["OrderStatus"] = [{ "CategoryID": 10101, "CategoryTitle": "待预订", "CategoryCode": "WaitBooking" }, { "CategoryID": 10105, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 10107, "CategoryTitle": "待支付", "CategoryCode": "WaitPayment" }, { "CategoryID": 10109, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" }, { "CategoryID": 10113, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 10115, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }, { "CategoryID": 10117, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }, { "CategoryID": 10121, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }];

data["DealStatus"] = [{ "CategoryID": 10101, "CategoryTitle": "待预订", "CategoryCode": "WaitBooking" }, { "CategoryID": 10105, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 10107, "CategoryTitle": "待支付", "CategoryCode": "WaitPayment" }, { "CategoryID": 10109, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" }, { "CategoryID": 10113, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 10115, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }, { "CategoryID": 10117, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }, { "CategoryID": 10121, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }];
data["AmendStatus"] = [{ "CategoryID": 10201, "CategoryTitle": "待提交", "CategoryCode": "WaitSubmit" }, { "CategoryID": 10203, "CategoryTitle": "待核价", "CategoryCode": "WaitDispose" }, { "CategoryID": 10205, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" }, { "CategoryID": 10209, "CategoryTitle": "待退款", "CategoryCode": "WaitRefund" }, { "CategoryID": 10213, "CategoryTitle": "已完成", "CategoryCode": "Finished" }, { "CategoryID": 10215, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" }, { "CategoryID": 10217, "CategoryTitle": "已退回", "CategoryCode": "Rejected" }, { "CategoryID": 10221, "CategoryTitle": "已取消", "CategoryCode": "Canceled" }];
data["Numbers"] = [{ "CategoryID": 1, "CategoryTitle": "单", "CategoryCode": "一" }, { "CategoryID": 2, "CategoryTitle": "双", "CategoryCode": "二" }, { "CategoryID": 3, "CategoryTitle": "三", "CategoryCode": "三" }, { "CategoryID": 4, "CategoryTitle": "四", "CategoryCode": "四" }, { "CategoryID": 5, "CategoryTitle": "五", "CategoryCode": "五" }, { "CategoryID": 6, "CategoryTitle": "六", "CategoryCode": "六" }, { "CategoryID": 7, "CategoryTitle": "七", "CategoryCode": "七" }, { "CategoryID": 8, "CategoryTitle": "八", "CategoryCode": "八" }, { "CategoryID": 9, "CategoryTitle": "九", "CategoryCode": "九" }, { "CategoryID": 0, "CategoryTitle": "无", "CategoryCode": "零" }];

data.types = {};
data.codes = {};
for (var key in data) {
    if (data.hasOwnProperty(key)) {
        var eles = data[key];
        var types = {};
        var codes = {};
        data.types[key] = types;
        data.codes[key] = codes;
        for (var i = 0; i < eles.length; i++) {
            types[eles[i].CategoryCode] = eles[i].CategoryID;
            codes[eles[i].CategoryID] = eles[i].CategoryCode;
        }
    }
}
/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ })

},[277]);


// WEBPACK FOOTER //
// static/js/app.2f110f5c263ed2d424f5.js